/* tslint:disable */
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
};

export type AchievementObject = {
   __typename?: 'AchievementObject',
  id: Scalars['Int'],
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  descriptionInactive?: Maybe<Scalars['String']>,
  imageId?: Maybe<Scalars['Int']>,
  image?: Maybe<Scalars['String']>,
  imageInactive?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  ruleKey?: Maybe<Scalars['String']>,
  position?: Maybe<Scalars['Int']>,
  sourceLanguage?: Maybe<LanguageObject>,
};

export type AutocompleteEntryObject = {
   __typename?: 'AutocompleteEntryObject',
  id?: Maybe<Scalars['Int']>,
  text?: Maybe<Scalars['String']>,
};

export type CardObject = {
   __typename?: 'CardObject',
  id?: Maybe<Scalars['Int']>,
  postTitle?: Maybe<Scalars['String']>,
  postAuthorName?: Maybe<Scalars['String']>,
  exampleSentence?: Maybe<Scalars['String']>,
  exampleSentenceOriginal?: Maybe<Scalars['String']>,
  sentenceAudio?: Maybe<Scalars['String']>,
  sentenceAudioOriginal?: Maybe<Scalars['String']>,
  explanationRules?: Maybe<Scalars['String']>,
  infinitivesOnly?: Maybe<Scalars['String']>,
  quotaExplanation1?: Maybe<Scalars['String']>,
  counterQuotaExplanation1?: Maybe<Scalars['String']>,
  exampleSentenceTranslation?: Maybe<Scalars['String']>,
  exampleSentenceTranslationOriginal?: Maybe<Scalars['String']>,
  exampleSentence2?: Maybe<Scalars['String']>,
  exampleSentence2Original?: Maybe<Scalars['String']>,
  sentenceAudio2?: Maybe<Scalars['String']>,
  sentenceAudio2Original?: Maybe<Scalars['String']>,
  infinitivesOnly2?: Maybe<Scalars['String']>,
  quotaExplanation2?: Maybe<Scalars['String']>,
  counterQuotaExplanation2?: Maybe<Scalars['String']>,
  exampleSentenceTranslation2?: Maybe<Scalars['String']>,
  exampleSentenceTranslation2Original?: Maybe<Scalars['String']>,
  info?: Maybe<Scalars['String']>,
  infoDisapproveComment?: Maybe<Scalars['String']>,
  editingRequiredAt?: Maybe<Scalars['String']>,
  editingRequiredComment?: Maybe<Scalars['String']>,
  derivableFromWords?: Maybe<Scalars['String']>,
  exerciseTranslation?: Maybe<Scalars['String']>,
  falseAnswers?: Maybe<Scalars['String']>,
  topic?: Maybe<TopicObject>,
  explanation?: Maybe<CardObject>,
  previouslyCreatedVocabulary?: Maybe<CardObject>,
  explanationExercises: Array<CardObject>,
  cardType?: Maybe<Scalars['Int']>,
  reviewDescription?: Maybe<Scalars['String']>,
  creator?: Maybe<Scalars['String']>,
  creatorName?: Maybe<Scalars['String']>,
  approving?: Maybe<Scalars['String']>,
  approvedAt?: Maybe<Scalars['String']>,
  disapprovedAt?: Maybe<Scalars['String']>,
  approvingName?: Maybe<Scalars['String']>,
  escalating?: Maybe<Scalars['String']>,
  feedback?: Maybe<Scalars['Int']>,
  escalatingName?: Maybe<Scalars['String']>,
  escalationWasCorrect?: Maybe<Scalars['Boolean']>,
  escalationWasIncorrect?: Maybe<Scalars['Boolean']>,
  reviewedAt?: Maybe<Scalars['String']>,
  stage?: Maybe<StageObject>,
  course?: Maybe<CourseObject>,
  mnemo?: Maybe<MnemoObject>,
  wordTranslation?: Maybe<WordTranslationObject>,
};

export type CardsListObject = {
   __typename?: 'CardsListObject',
  count: Scalars['Int'],
  cards: Array<CardObject>,
};

export type CourseObject = {
   __typename?: 'CourseObject',
  id: Scalars['Int'],
  title: Scalars['String'],
  sourceLanguage?: Maybe<LanguageObject>,
  translationLanguage?: Maybe<LanguageObject>,
  stages: Array<StageObject>,
};

export type CreatorObject = {
   __typename?: 'CreatorObject',
  id?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  registered?: Maybe<Scalars['String']>,
  allowedCourses: Array<Scalars['String']>,
  stats?: Maybe<PeriodStatsObject>,
};

export type IndexedCardObject = {
   __typename?: 'IndexedCardObject',
  id?: Maybe<Scalars['Int']>,
  cardType?: Maybe<Scalars['Int']>,
  courseId?: Maybe<Scalars['Int']>,
  sourceLemma?: Maybe<Scalars['String']>,
  translationLemma?: Maybe<Scalars['String']>,
  translationId?: Maybe<Scalars['Int']>,
  exerciseTitle?: Maybe<Scalars['String']>,
  explanationTitle?: Maybe<Scalars['String']>,
  audio?: Maybe<Scalars['String']>,
  wordRank?: Maybe<Scalars['Int']>,
  sentence1?: Maybe<Scalars['String']>,
  sentence2?: Maybe<Scalars['String']>,
  sentence1Audio?: Maybe<Scalars['String']>,
  sentence2Audio?: Maybe<Scalars['String']>,
  sentence1Translation?: Maybe<Scalars['String']>,
  sentence2Translation?: Maybe<Scalars['String']>,
  info?: Maybe<Scalars['String']>,
  courseSourceLanguageCode?: Maybe<Scalars['String']>,
  courseSourceLanguageName?: Maybe<Scalars['String']>,
  courseTranslationLanguageCode?: Maybe<Scalars['String']>,
  courseTranslationLanguageName?: Maybe<Scalars['String']>,
  derivable?: Maybe<Scalars['String']>,
  mnemoKeyword?: Maybe<Scalars['String']>,
  mnemoShortSentence?: Maybe<Scalars['String']>,
  mnemoSentence?: Maybe<Scalars['String']>,
  stageId?: Maybe<Scalars['Int']>,
  stageLevel?: Maybe<Scalars['Int']>,
  topicId?: Maybe<Scalars['Int']>,
  topicTitle?: Maybe<Scalars['String']>,
  topicDescription?: Maybe<Scalars['String']>,
  topicRelated?: Maybe<Scalars['String']>,
  relatedExplanationId?: Maybe<Scalars['Int']>,
  explanationRules?: Maybe<Scalars['String']>,
  exerciseRules?: Maybe<Scalars['String']>,
  exerciseFalseAnswers?: Maybe<Scalars['String']>,
  exerciseTranslation?: Maybe<Scalars['String']>,
};

export type LanguageObject = {
   __typename?: 'LanguageObject',
  id: Scalars['Int'],
  name?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
};

export type LegObject = {
   __typename?: 'LegObject',
  id: Scalars['Int'],
  postTitle?: Maybe<Scalars['String']>,
  stage: StageObject,
  position?: Maybe<Scalars['Int']>,
  image?: Maybe<Scalars['String']>,
  imageId?: Maybe<Scalars['Int']>,
  popupPicture?: Maybe<Scalars['String']>,
  popupPictureId?: Maybe<Scalars['Int']>,
  imagePortrait?: Maybe<Scalars['String']>,
  imagePortraitId?: Maybe<Scalars['Int']>,
};

export type MnemoObject = {
   __typename?: 'MnemoObject',
  id?: Maybe<Scalars['Int']>,
  postTitle?: Maybe<Scalars['String']>,
  card?: Maybe<CardObject>,
  mnemoKeyword?: Maybe<Scalars['String']>,
  shortSentence?: Maybe<Scalars['String']>,
  sentence?: Maybe<Scalars['String']>,
  createdAt?: Maybe<Scalars['String']>,
  approvedAt?: Maybe<Scalars['String']>,
  disapprovedAt?: Maybe<Scalars['String']>,
  disapproveComment?: Maybe<Scalars['String']>,
  escalationWasCorrect?: Maybe<Scalars['String']>,
  escalationWasIncorrect?: Maybe<Scalars['String']>,
  reviewedAt?: Maybe<Scalars['String']>,
  skipped?: Maybe<Scalars['String']>,
  feedback?: Maybe<Scalars['Int']>,
  excluded?: Maybe<Scalars['String']>,
  approving?: Maybe<Scalars['String']>,
  approvingName?: Maybe<Scalars['String']>,
  escalating?: Maybe<Scalars['String']>,
  escalatingName?: Maybe<Scalars['String']>,
  postAuthorName?: Maybe<Scalars['String']>,
};

export type Mutation = {
   __typename?: 'Mutation',
  createLeg: LegObject,
  updateLeg: LegObject,
  createWord: WordObject,
  updateWord: WordObject,
  createCourse: CourseObject,
  updateCourse: CourseObject,
  createWordTranslation: WordTranslationObject,
  updateWordTranslation: WordTranslationObject,
  updateMeta: Scalars['Boolean'],
  updateUser: Scalars['Boolean'],
  addSubscription: Scalars['Boolean'],
  createCard: CardObject,
  updateCard: CardObject,
  updateMnemo: MnemoObject,
  releaseMnemos: Scalars['Boolean'],
  createTopic: TopicObject,
  updateTopic: TopicObject,
  createAchievement: AchievementObject,
  updateAchievement: AchievementObject,
  createStage: StageObject,
};


export type MutationCreateLegArgs = {
  input: UpdateLegInput
};


export type MutationUpdateLegArgs = {
  id: Scalars['Int'],
  input: UpdateLegInput
};


export type MutationCreateWordArgs = {
  input: UpdateWordInput
};


export type MutationUpdateWordArgs = {
  id: Scalars['Int'],
  input: UpdateWordInput
};


export type MutationCreateCourseArgs = {
  input: UpdateCourseInput
};


export type MutationUpdateCourseArgs = {
  id: Scalars['Int'],
  input: UpdateCourseInput
};


export type MutationCreateWordTranslationArgs = {
  input: UpdateWordTranslationInput
};


export type MutationUpdateWordTranslationArgs = {
  id: Scalars['Int'],
  input: UpdateWordTranslationInput
};


export type MutationUpdateMetaArgs = {
  userId: Scalars['Int'],
  key: Scalars['String'],
  value: Scalars['String']
};


export type MutationUpdateUserArgs = {
  userId: Scalars['Int'],
  email?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>
};


export type MutationAddSubscriptionArgs = {
  userId: Scalars['Int'],
  courseId?: Maybe<Scalars['Int']>,
  all?: Maybe<Scalars['Boolean']>,
  removeAll?: Maybe<Scalars['Boolean']>
};


export type MutationCreateCardArgs = {
  input: UpdateCardInput
};


export type MutationUpdateCardArgs = {
  id: Scalars['Int'],
  editMode?: Maybe<Scalars['Boolean']>,
  input: UpdateCardInput
};


export type MutationUpdateMnemoArgs = {
  id: Scalars['Int'],
  input: UpdateMnemoInput
};


export type MutationReleaseMnemosArgs = {
  items: Array<ReleaseInputInput>
};


export type MutationCreateTopicArgs = {
  input: UpdateTopicInput
};


export type MutationUpdateTopicArgs = {
  id: Scalars['Int'],
  input: UpdateTopicInput
};


export type MutationCreateAchievementArgs = {
  input: UpdateAchievementInput
};


export type MutationUpdateAchievementArgs = {
  id: Scalars['Int'],
  input: UpdateAchievementInput
};


export type MutationCreateStageArgs = {
  input: UpdateStageInput
};

export type OptimizedAudioObject = {
   __typename?: 'OptimizedAudioObject',
  status?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
  message?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type PeriodItemInput = {
  name?: Maybe<Scalars['String']>,
  dateStart?: Maybe<Scalars['String']>,
  dateEnd?: Maybe<Scalars['String']>,
};

export type PeriodStatsObject = {
   __typename?: 'PeriodStatsObject',
  period?: Maybe<Scalars['String']>,
  details?: Maybe<StatsObject>,
};

export type Query = {
   __typename?: 'Query',
  leg: LegObject,
  stageLegs: Array<LegObject>,
  searchAlreadyCreatedCards: Array<AutocompleteEntryObject>,
  searchTranslations: Array<AutocompleteEntryObject>,
  word: WordObject,
  wordsMasks: Array<WordMaskObject>,
  allowedCourses: Array<CourseObject>,
  coursesByLanguage: Array<CourseObject>,
  courses: Array<CourseObject>,
  wordTranslation: WordTranslationObject,
  searchWordTranslation: WordTranslationObject,
  hello: Scalars['String'],
  me: UserObject,
  allUsers: Array<UserObject>,
  user: UserObject,
  searchUserByEmail?: Maybe<UserAdminObject>,
  nextCardUrl?: Maybe<Scalars['String']>,
  searchCards: Array<IndexedCardObject>,
  topicExplanations: Array<CardObject>,
  topicExercises: Array<CardObject>,
  recentExplanations: Array<CardObject>,
  cardsList: CardsListObject,
  card: CardObject,
  recentTopic: RecentTopicObject,
  answersList: Array<UserAnswerObject>,
  quotaCheck: QuotaObject,
  optimizedAudioAvailable: OptimizedAudioObject,
  languages: Array<LanguageObject>,
  stats: Array<PeriodStatsObject>,
  rolesList: Array<CreatorObject>,
  cardsPerDay: Scalars['Int'],
  mnemo: MnemoObject,
  unreleasedMnemos: Array<CardObject>,
  topic: TopicObject,
  topicsByIds: Array<TopicObject>,
  searchTopics: Array<TopicObject>,
  progressAchievements: Array<AchievementObject>,
  achievement: AchievementObject,
  stageForCourse: StageObject,
  courseStages: StageObject,
};


export type QueryLegArgs = {
  id: Scalars['Int']
};


export type QueryStageLegsArgs = {
  stage: Scalars['Int']
};


export type QuerySearchAlreadyCreatedCardsArgs = {
  query: Scalars['String'],
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int']
};


export type QuerySearchTranslationsArgs = {
  query: Scalars['String'],
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int']
};


export type QueryWordArgs = {
  id: Scalars['Int']
};


export type QueryWordsMasksArgs = {
  pos?: Maybe<Scalars['String']>,
  rank?: Maybe<Scalars['Int']>,
  course?: Maybe<Scalars['Int']>
};


export type QueryAllowedCoursesArgs = {
  userId?: Maybe<Scalars['Int']>
};


export type QueryCoursesByLanguageArgs = {
  languageId: Scalars['Int']
};


export type QueryWordTranslationArgs = {
  id: Scalars['Int']
};


export type QuerySearchWordTranslationArgs = {
  courseId: Scalars['Int'],
  text: Scalars['String']
};


export type QueryHelloArgs = {
  name: Scalars['String']
};


export type QueryAllUsersArgs = {
  roles?: Maybe<Array<Scalars['String']>>
};


export type QueryUserArgs = {
  id: Scalars['Int']
};


export type QuerySearchUserByEmailArgs = {
  email: Scalars['String']
};


export type QueryNextCardUrlArgs = {
  courseId: Scalars['Int'],
  role: Scalars['String'],
  backIntoCreationStream?: Maybe<Scalars['Int']>
};


export type QuerySearchCardsArgs = {
  word?: Maybe<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
  courseId?: Maybe<Scalars['Int']>
};


export type QueryTopicExplanationsArgs = {
  topic: Scalars['Int']
};


export type QueryTopicExercisesArgs = {
  topic: Scalars['Int']
};


export type QueryRecentExplanationsArgs = {
  topic: Scalars['Int']
};


export type QueryCardsListArgs = {
  userId?: Maybe<Scalars['Int']>,
  languageId: Scalars['Int'],
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  type: Scalars['String'],
  search?: Maybe<Scalars['String']>
};


export type QueryCardArgs = {
  id: Scalars['Int']
};


export type QueryRecentTopicArgs = {
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int'],
  cardId?: Maybe<Scalars['Int']>,
  rank?: Maybe<Scalars['Int']>
};


export type QueryAnswersListArgs = {
  userId: Scalars['Int']
};


export type QueryQuotaCheckArgs = {
  grammar?: Maybe<Scalars['Boolean']>,
  values: Array<Scalars['String']>,
  excludedWords: Array<Scalars['String']>,
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int']
};


export type QueryOptimizedAudioAvailableArgs = {
  id: Scalars['Int'],
  fileUrl: Scalars['String'],
  noTimeout?: Maybe<Scalars['Boolean']>
};


export type QueryStatsArgs = {
  my?: Maybe<Scalars['Boolean']>,
  role: Scalars['String'],
  userId?: Maybe<Scalars['Int']>,
  courseId?: Maybe<Scalars['Int']>,
  periods: Array<PeriodItemInput>
};


export type QueryRolesListArgs = {
  role: Scalars['String'],
  courseId?: Maybe<Scalars['Int']>
};


export type QueryCardsPerDayArgs = {
  role: Scalars['String']
};


export type QueryMnemoArgs = {
  id: Scalars['Int']
};


export type QueryUnreleasedMnemosArgs = {
  courseId: Scalars['Int']
};


export type QueryTopicArgs = {
  id: Scalars['Int']
};


export type QueryTopicsByIdsArgs = {
  ids: Array<Scalars['Int']>
};


export type QuerySearchTopicsArgs = {
  query: Scalars['String']
};


export type QueryProgressAchievementsArgs = {
  languageId: Scalars['Int']
};


export type QueryAchievementArgs = {
  id: Scalars['Int']
};


export type QueryStageForCourseArgs = {
  courseId: Scalars['Int']
};


export type QueryCourseStagesArgs = {
  courseId: Scalars['Int']
};

export type QuotaObject = {
   __typename?: 'QuotaObject',
  success?: Maybe<Scalars['Boolean']>,
  content?: Maybe<Scalars['String']>,
  valid?: Maybe<Scalars['Boolean']>,
  quotaData?: Maybe<Scalars['String']>,
};

export type RecentTopicObject = {
   __typename?: 'RecentTopicObject',
  topic?: Maybe<TopicObject>,
  explanation?: Maybe<CardObject>,
  cards: Array<CardObject>,
};

export type ReleaseInputInput = {
  id?: Maybe<Scalars['Int']>,
  excluded?: Maybe<Scalars['Boolean']>,
};

export type StageObject = {
   __typename?: 'StageObject',
  id: Scalars['Int'],
  level: Scalars['Int'],
  countExplanationCards: Scalars['Int'],
  topics: Array<TopicObject>,
  course?: Maybe<CourseObject>,
};

export type StatsObject = {
   __typename?: 'StatsObject',
  mediaCreated?: Maybe<Scalars['Int']>,
  mediaGood?: Maybe<Scalars['Int']>,
  mediaGoodPercent?: Maybe<Scalars['String']>,
  mediaReviewed?: Maybe<Scalars['Int']>,
  mediaEscalated?: Maybe<Scalars['Int']>,
  mnemoCreated?: Maybe<Scalars['Int']>,
  mnemoBillable?: Maybe<Scalars['Int']>,
  mnemoBillablePercent?: Maybe<Scalars['String']>,
  mnemoReviewed?: Maybe<Scalars['Int']>,
  mnemoEscalated?: Maybe<Scalars['Int']>,
  vocabularyCreated?: Maybe<Scalars['Int']>,
  vocabularyBillable?: Maybe<Scalars['Int']>,
  vocabularyBillablePercent?: Maybe<Scalars['String']>,
  exerciseCreated?: Maybe<Scalars['Int']>,
  exerciseBillable?: Maybe<Scalars['Int']>,
  exerciseBillablePercent?: Maybe<Scalars['String']>,
  totalReviewed?: Maybe<Scalars['Int']>,
  totalEscalated?: Maybe<Scalars['Int']>,
  totalQs?: Maybe<Scalars['Float']>,
  vocabularyQs?: Maybe<Scalars['Float']>,
  exerciseQs?: Maybe<Scalars['Float']>,
  reviewQs?: Maybe<Scalars['Float']>,
  cardsPerDay?: Maybe<Scalars['Int']>,
};

export type TopicObject = {
   __typename?: 'TopicObject',
  id: Scalars['Int'],
  title: Scalars['String'],
  description: Scalars['String'],
  stage?: Maybe<StageObject>,
  relatedTopics?: Maybe<Scalars['String']>,
};

export type UpdateAchievementInput = {
  postTitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  descriptionInactive?: Maybe<Scalars['String']>,
  image?: Maybe<Scalars['String']>,
  imageInactive?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  ruleKey?: Maybe<Scalars['String']>,
  position?: Maybe<Scalars['String']>,
  sourceLanguage?: Maybe<Scalars['Int']>,
};

export type UpdateCardInput = {
  postTitle?: Maybe<Scalars['String']>,
  exampleSentence?: Maybe<Scalars['String']>,
  sentenceAudio?: Maybe<Scalars['String']>,
  infinitivesOnly?: Maybe<Scalars['String']>,
  quotaExplanation1?: Maybe<Scalars['String']>,
  counterQuotaExplanation1?: Maybe<Scalars['String']>,
  exampleSentenceTranslation?: Maybe<Scalars['String']>,
  exampleSentence2?: Maybe<Scalars['String']>,
  sentenceAudio2?: Maybe<Scalars['String']>,
  infinitivesOnly2?: Maybe<Scalars['String']>,
  quotaExplanation2?: Maybe<Scalars['String']>,
  counterQuotaExplanation2?: Maybe<Scalars['String']>,
  exampleSentenceTranslation2?: Maybe<Scalars['String']>,
  info?: Maybe<Scalars['String']>,
  infoFilledAt?: Maybe<Scalars['String']>,
  infoApprovedAt?: Maybe<Scalars['String']>,
  infoReviewedAt?: Maybe<Scalars['String']>,
  infoDisapprovedAt?: Maybe<Scalars['String']>,
  infoEscalationWasCorrect?: Maybe<Scalars['String']>,
  infoEscalationWasIncorrect?: Maybe<Scalars['String']>,
  editingRequiredAt?: Maybe<Scalars['String']>,
  editingRequiredComment?: Maybe<Scalars['String']>,
  derivableFromWords?: Maybe<Scalars['String']>,
  exerciseTranslation?: Maybe<Scalars['String']>,
  falseAnswers?: Maybe<Scalars['String']>,
  explanationRules?: Maybe<Scalars['String']>,
  infoDisapproveComment?: Maybe<Scalars['String']>,
  reviewDescription?: Maybe<Scalars['String']>,
  isFullyFinished?: Maybe<Scalars['String']>,
  reviewedAt?: Maybe<Scalars['String']>,
  approvedAt?: Maybe<Scalars['String']>,
  disapprovedAt?: Maybe<Scalars['String']>,
  escalationWasCorrect?: Maybe<Scalars['String']>,
  escalationWasIncorrect?: Maybe<Scalars['String']>,
  cardFeedback?: Maybe<Scalars['Int']>,
  topic?: Maybe<Scalars['Int']>,
  explanation?: Maybe<Scalars['Int']>,
  cardType?: Maybe<Scalars['Int']>,
  creator?: Maybe<Scalars['Int']>,
  stage?: Maybe<Scalars['Int']>,
  course?: Maybe<Scalars['Int']>,
  wordTranslation?: Maybe<Scalars['Int']>,
};

export type UpdateCourseInput = {
  postTitle?: Maybe<Scalars['String']>,
  sourceLanguage?: Maybe<Scalars['Int']>,
  translationLanguage?: Maybe<Scalars['Int']>,
  frontendName?: Maybe<Scalars['String']>,
};

export type UpdateLegInput = {
  postTitle?: Maybe<Scalars['String']>,
  stage?: Maybe<Scalars['Int']>,
  position?: Maybe<Scalars['Int']>,
  image?: Maybe<Scalars['String']>,
  popupPicture?: Maybe<Scalars['String']>,
  imagePortrait?: Maybe<Scalars['String']>,
};

export type UpdateMnemoInput = {
  postTitle?: Maybe<Scalars['String']>,
  card?: Maybe<Scalars['Int']>,
  keyword?: Maybe<Scalars['String']>,
  shortSentence?: Maybe<Scalars['String']>,
  sentence?: Maybe<Scalars['String']>,
  createdAt?: Maybe<Scalars['String']>,
  skipped?: Maybe<Scalars['String']>,
  excluded?: Maybe<Scalars['String']>,
  reviewedAt?: Maybe<Scalars['String']>,
  approvedAt?: Maybe<Scalars['String']>,
  disapproveComment?: Maybe<Scalars['String']>,
  cardFeedback?: Maybe<Scalars['Int']>,
  disapprovedAt?: Maybe<Scalars['String']>,
  escalationWasCorrect?: Maybe<Scalars['String']>,
  escalationWasIncorrect?: Maybe<Scalars['String']>,
};

export type UpdateStageInput = {
  postTitle?: Maybe<Scalars['String']>,
  course?: Maybe<Scalars['Int']>,
  level?: Maybe<Scalars['Int']>,
};

export type UpdateTopicInput = {
  postTitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  stage?: Maybe<Scalars['Int']>,
  image?: Maybe<Scalars['String']>,
  rule?: Maybe<Scalars['String']>,
  explanation?: Maybe<Scalars['String']>,
  examples?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  relatedTopics?: Maybe<Scalars['String']>,
};

export type UpdateWordInput = {
  postTitle?: Maybe<Scalars['String']>,
  language?: Maybe<Scalars['Int']>,
  rank?: Maybe<Scalars['Int']>,
  lemma?: Maybe<Scalars['String']>,
  pos?: Maybe<Scalars['String']>,
  predefinedTranslation?: Maybe<Scalars['Int']>,
  predefinedComment?: Maybe<Scalars['String']>,
  posDefinition?: Maybe<Scalars['String']>,
};

export type UpdateWordTranslationInput = {
  postTitle?: Maybe<Scalars['String']>,
  sourceWord?: Maybe<Scalars['Int']>,
  sourceLanguage?: Maybe<Scalars['Int']>,
  translationLanguage?: Maybe<Scalars['Int']>,
  translation?: Maybe<Scalars['Int']>,
  audio?: Maybe<Scalars['String']>,
  separateMeanings?: Maybe<Scalars['Boolean']>,
};

export type UserAdminObject = {
   __typename?: 'UserAdminObject',
  id: Scalars['Int'],
  coursesEnabled: Array<Scalars['Int']>,
  allCoursesEnabled?: Maybe<Scalars['Boolean']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  registered?: Maybe<Scalars['String']>,
  emailConfirmed?: Maybe<Scalars['Boolean']>,
  courses: Array<UserCourseObject>,
};

export type UserAnswerObject = {
   __typename?: 'UserAnswerObject',
  id?: Maybe<Scalars['String']>,
  log?: Maybe<Scalars['String']>,
  cardId?: Maybe<Scalars['Int']>,
  state?: Maybe<Scalars['String']>,
  nextShow?: Maybe<Scalars['String']>,
  isSkipped?: Maybe<Scalars['Boolean']>,
  selfEvaluation?: Maybe<Scalars['Int']>,
  date?: Maybe<Scalars['String']>,
  card?: Maybe<CardObject>,
};

export type UserCourseObject = {
   __typename?: 'UserCourseObject',
  id: Scalars['Int'],
  name: Scalars['String'],
  nextVocabulary?: Maybe<Scalars['Int']>,
  finished?: Maybe<Scalars['Boolean']>,
  isAvailable: Scalars['Boolean'],
};

export type UserObject = {
   __typename?: 'UserObject',
  id: Scalars['Int'],
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  userLogin?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  roles: Array<Scalars['String']>,
};

export type WordMaskObject = {
   __typename?: 'WordMaskObject',
  id?: Maybe<Scalars['Int']>,
  rank?: Maybe<Scalars['Int']>,
  word?: Maybe<Scalars['String']>,
};

export type WordObject = {
   __typename?: 'WordObject',
  id: Scalars['Int'],
  lemma: Scalars['String'],
  rank: Scalars['Int'],
  pos: Scalars['String'],
  predefinedTranslation?: Maybe<WordTranslationObject>,
  predefinedComment: Scalars['String'],
  posDefinition?: Maybe<Scalars['String']>,
};

export type WordTranslationObject = {
   __typename?: 'WordTranslationObject',
  id: Scalars['Int'],
  separateMeanings?: Maybe<Scalars['Boolean']>,
  audio?: Maybe<Scalars['String']>,
  translation?: Maybe<Scalars['String']>,
  sourceWord?: Maybe<WordObject>,
  translationWord?: Maybe<WordObject>,
  sourceLanguage?: Maybe<LanguageObject>,
  translationLanguage?: Maybe<LanguageObject>,
};

export type CreateAchievementMutationVariables = {
  data: UpdateAchievementInput
};


export type CreateAchievementMutation = (
  { __typename?: 'Mutation' }
  & { createAchievement: (
    { __typename?: 'AchievementObject' }
    & Pick<AchievementObject, 'id'>
  ) }
);

export type UpdateAchievementMutationVariables = {
  id: Scalars['Int'],
  data: UpdateAchievementInput
};


export type UpdateAchievementMutation = (
  { __typename?: 'Mutation' }
  & { updateAchievement: (
    { __typename?: 'AchievementObject' }
    & Pick<AchievementObject, 'id'>
  ) }
);

export type CreateCardMutationVariables = {
  input: UpdateCardInput
};


export type CreateCardMutation = (
  { __typename?: 'Mutation' }
  & { createCard: (
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id'>
  ) }
);

export type ReleaseMnemosMutationVariables = {
  data: Array<ReleaseInputInput>
};


export type ReleaseMnemosMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'releaseMnemos'>
);

export type UpdateCardMutationVariables = {
  id: Scalars['Int'],
  input: UpdateCardInput,
  editMode?: Maybe<Scalars['Boolean']>
};


export type UpdateCardMutation = (
  { __typename?: 'Mutation' }
  & { updateCard: (
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id'>
  ) }
);

export type UpdateMnemoMutationVariables = {
  id: Scalars['Int'],
  input: UpdateMnemoInput
};


export type UpdateMnemoMutation = (
  { __typename?: 'Mutation' }
  & { updateMnemo: (
    { __typename?: 'MnemoObject' }
    & Pick<MnemoObject, 'id'>
  ) }
);

export type CreateCourseMutationVariables = {
  input: UpdateCourseInput
};


export type CreateCourseMutation = (
  { __typename?: 'Mutation' }
  & { createCourse: (
    { __typename?: 'CourseObject' }
    & Pick<CourseObject, 'id'>
  ) }
);

export type UpdateCourseMutationVariables = {
  id: Scalars['Int'],
  input: UpdateCourseInput
};


export type UpdateCourseMutation = (
  { __typename?: 'Mutation' }
  & { updateCourse: (
    { __typename?: 'CourseObject' }
    & Pick<CourseObject, 'id'>
  ) }
);

export type CreateLegMutationVariables = {
  input: UpdateLegInput
};


export type CreateLegMutation = (
  { __typename?: 'Mutation' }
  & { createLeg: (
    { __typename?: 'LegObject' }
    & Pick<LegObject, 'id'>
  ) }
);

export type UpdateLegMutationVariables = {
  id: Scalars['Int'],
  input: UpdateLegInput
};


export type UpdateLegMutation = (
  { __typename?: 'Mutation' }
  & { updateLeg: (
    { __typename?: 'LegObject' }
    & Pick<LegObject, 'id'>
  ) }
);

export type CreateStageMutationVariables = {
  input: UpdateStageInput
};


export type CreateStageMutation = (
  { __typename?: 'Mutation' }
  & { createStage: (
    { __typename?: 'StageObject' }
    & Pick<StageObject, 'id' | 'countExplanationCards' | 'level'>
    & { topics: Array<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id'>
    )> }
  ) }
);

export type CreateTopicMutationVariables = {
  input: UpdateTopicInput
};


export type CreateTopicMutation = (
  { __typename?: 'Mutation' }
  & { createTopic: (
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id'>
  ) }
);

export type UpdateTopicMutationVariables = {
  id: Scalars['Int'],
  input: UpdateTopicInput
};


export type UpdateTopicMutation = (
  { __typename?: 'Mutation' }
  & { updateTopic: (
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id'>
  ) }
);

export type CreateWordTranslationMutationVariables = {
  input: UpdateWordTranslationInput
};


export type CreateWordTranslationMutation = (
  { __typename?: 'Mutation' }
  & { createWordTranslation: (
    { __typename?: 'WordTranslationObject' }
    & Pick<WordTranslationObject, 'id'>
  ) }
);

export type UpdateWordTranslationMutationVariables = {
  id: Scalars['Int'],
  input: UpdateWordTranslationInput
};


export type UpdateWordTranslationMutation = (
  { __typename?: 'Mutation' }
  & { updateWordTranslation: (
    { __typename?: 'WordTranslationObject' }
    & Pick<WordTranslationObject, 'id'>
  ) }
);

export type UpdateMetaMutationVariables = {
  userId: Scalars['Int'],
  key: Scalars['String'],
  value: Scalars['String']
};


export type UpdateMetaMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateMeta'>
);

export type UpdateUserMutationVariables = {
  userId: Scalars['Int'],
  email?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>
};


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateUser'>
);

export type CreateWordMutationVariables = {
  input: UpdateWordInput
};


export type CreateWordMutation = (
  { __typename?: 'Mutation' }
  & { createWord: (
    { __typename?: 'WordObject' }
    & Pick<WordObject, 'id' | 'lemma'>
  ) }
);

export type AchievementQueryVariables = {
  id: Scalars['Int']
};


export type AchievementQuery = (
  { __typename?: 'Query' }
  & { achievement: (
    { __typename?: 'AchievementObject' }
    & Pick<AchievementObject, 'id' | 'description' | 'imageId' | 'image' | 'type' | 'position'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id'>
    )> }
  ) }
);

export type ProgressAchievementsQueryVariables = {
  language: Scalars['Int']
};


export type ProgressAchievementsQuery = (
  { __typename?: 'Query' }
  & { progressAchievements: Array<(
    { __typename?: 'AchievementObject' }
    & Pick<AchievementObject, 'id' | 'description' | 'imageId' | 'image' | 'type' | 'position'>
  )> }
);

export type AnswersListQueryVariables = {
  userId: Scalars['Int']
};


export type AnswersListQuery = (
  { __typename?: 'Query' }
  & { answersList: Array<(
    { __typename?: 'UserAnswerObject' }
    & Pick<UserAnswerObject, 'log' | 'state' | 'date' | 'nextShow' | 'isSkipped' | 'selfEvaluation'>
    & { card: Maybe<(
      { __typename?: 'CardObject' }
      & Pick<CardObject, 'id' | 'cardType' | 'postTitle'>
      & { wordTranslation: Maybe<(
        { __typename?: 'WordTranslationObject' }
        & { sourceWord: Maybe<(
          { __typename?: 'WordObject' }
          & Pick<WordObject, 'lemma'>
        )> }
      )> }
    )> }
  )> }
);

export type CardsCountersQueryVariables = {
  userId?: Maybe<Scalars['Int']>,
  languageId: Scalars['Int'],
  createdType: Scalars['String'],
  rejectedType: Scalars['String'],
  pendingType: Scalars['String'],
  pendingEscalationType: Scalars['String'],
  reviewedType: Scalars['String'],
  escalatedType: Scalars['String']
};


export type CardsCountersQuery = (
  { __typename?: 'Query' }
  & { created: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ), rejected: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ), pending: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ), pendingEscalation: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ), reviewed: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ), escalated: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
  ) }
);

export type CardsListQueryVariables = {
  userId?: Maybe<Scalars['Int']>,
  search?: Maybe<Scalars['String']>,
  languageId: Scalars['Int'],
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  type: Scalars['String']
};


export type CardsListQuery = (
  { __typename?: 'Query' }
  & { cardsList: (
    { __typename?: 'CardsListObject' }
    & Pick<CardsListObject, 'count'>
    & { cards: Array<(
      { __typename?: 'CardObject' }
      & ExtendedCardFragment
    )> }
  ) }
);

export type GetExerciseCardByIdQueryVariables = {
  id: Scalars['Int']
};


export type GetExerciseCardByIdQuery = (
  { __typename?: 'Query' }
  & { card: (
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'falseAnswers' | 'exerciseTranslation' | 'explanationRules' | 'counterQuotaExplanation1' | 'quotaExplanation1' | 'infinitivesOnly' | 'postAuthorName' | 'approvingName' | 'reviewDescription' | 'approvedAt' | 'disapprovedAt'>
    & { course: Maybe<(
      { __typename?: 'CourseObject' }
      & Pick<CourseObject, 'id'>
      & { sourceLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id'>
      )>, translationLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id'>
      )> }
    )>, explanation: Maybe<(
      { __typename?: 'CardObject' }
      & Pick<CardObject, 'id' | 'explanationRules'>
      & { course: Maybe<(
        { __typename?: 'CourseObject' }
        & Pick<CourseObject, 'id'>
      )>, topic: Maybe<(
        { __typename?: 'TopicObject' }
        & Pick<TopicObject, 'id'>
      )>, explanationExercises: Array<(
        { __typename?: 'CardObject' }
        & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules' | 'exerciseTranslation' | 'falseAnswers' | 'infinitivesOnly'>
      )> }
    )>, topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id' | 'title' | 'description'>
    )>, previouslyCreatedVocabulary: Maybe<(
      { __typename?: 'CardObject' }
      & { wordTranslation: Maybe<(
        { __typename?: 'WordTranslationObject' }
        & { sourceWord: Maybe<(
          { __typename?: 'WordObject' }
          & Pick<WordObject, 'rank'>
        )> }
      )> }
    )> }
  ) }
);

export type ExplanationCardQueryVariables = {
  id: Scalars['Int']
};


export type ExplanationCardQuery = (
  { __typename?: 'Query' }
  & { card: (
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules'>
    & { topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id' | 'title' | 'description'>
    )>, course: Maybe<(
      { __typename?: 'CourseObject' }
      & Pick<CourseObject, 'id'>
    )> }
  ) }
);

export type ExtendedCardFragment = (
  { __typename?: 'CardObject' }
  & Pick<CardObject, 'id' | 'postTitle' | 'cardType' | 'creatorName' | 'approvingName' | 'escalatingName' | 'approvedAt' | 'disapprovedAt' | 'feedback' | 'falseAnswers' | 'explanationRules' | 'infinitivesOnly' | 'infinitivesOnly2' | 'reviewDescription' | 'exerciseTranslation' | 'exampleSentence' | 'exampleSentenceOriginal' | 'exampleSentence2' | 'exampleSentence2Original' | 'exampleSentenceTranslation' | 'exampleSentenceTranslationOriginal' | 'exampleSentenceTranslation2' | 'exampleSentenceTranslation2Original' | 'sentenceAudio' | 'sentenceAudioOriginal' | 'sentenceAudio2' | 'sentenceAudio2Original' | 'info' | 'editingRequiredAt' | 'editingRequiredComment' | 'derivableFromWords' | 'escalationWasCorrect' | 'escalationWasIncorrect' | 'reviewedAt'>
  & { explanation: Maybe<(
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules'>
    & { topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id' | 'title' | 'description'>
    )>, course: Maybe<(
      { __typename?: 'CourseObject' }
      & Pick<CourseObject, 'id' | 'title'>
    )> }
  )>, stage: Maybe<(
    { __typename?: 'StageObject' }
    & Pick<StageObject, 'level'>
  )>, topic: Maybe<(
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id' | 'title' | 'description'>
  )>, course: Maybe<(
    { __typename?: 'CourseObject' }
    & Pick<CourseObject, 'id'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'code' | 'name'>
    )>, translationLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'code' | 'name'>
    )> }
  )>, wordTranslation: Maybe<(
    { __typename?: 'WordTranslationObject' }
    & Pick<WordTranslationObject, 'id' | 'audio' | 'separateMeanings'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, translationLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, translationWord: Maybe<(
      { __typename?: 'WordObject' }
      & Pick<WordObject, 'id' | 'lemma'>
    )>, sourceWord: Maybe<(
      { __typename?: 'WordObject' }
      & Pick<WordObject, 'id' | 'lemma' | 'rank' | 'pos' | 'posDefinition'>
    )> }
  )>, mnemo: Maybe<(
    { __typename?: 'MnemoObject' }
    & Pick<MnemoObject, 'feedback' | 'mnemoKeyword' | 'shortSentence' | 'sentence' | 'approvingName' | 'approvedAt' | 'disapprovedAt' | 'escalatingName' | 'disapproveComment' | 'postAuthorName'>
  )> }
);

export type GetMnemoCardByIdQueryVariables = {
  id: Scalars['Int']
};


export type GetMnemoCardByIdQuery = (
  { __typename?: 'Query' }
  & { mnemo: (
    { __typename?: 'MnemoObject' }
    & Pick<MnemoObject, 'id' | 'feedback' | 'sentence' | 'shortSentence' | 'mnemoKeyword' | 'approvingName' | 'approvedAt' | 'postAuthorName' | 'disapprovedAt' | 'disapproveComment'>
    & { card: Maybe<(
      { __typename?: 'CardObject' }
      & { wordTranslation: Maybe<(
        { __typename?: 'WordTranslationObject' }
        & Pick<WordTranslationObject, 'audio'>
        & { sourceWord: Maybe<(
          { __typename?: 'WordObject' }
          & Pick<WordObject, 'lemma' | 'pos' | 'posDefinition' | 'rank'>
        )>, translationWord: Maybe<(
          { __typename?: 'WordObject' }
          & Pick<WordObject, 'lemma'>
        )>, sourceLanguage: Maybe<(
          { __typename?: 'LanguageObject' }
          & Pick<LanguageObject, 'id' | 'name'>
        )>, translationLanguage: Maybe<(
          { __typename?: 'LanguageObject' }
          & Pick<LanguageObject, 'id' | 'name'>
        )> }
      )> }
    )> }
  ) }
);

export type GetRecentTopicQueryVariables = {
  translationLanguage: Scalars['Int'],
  sourceLanguage: Scalars['Int'],
  cardId: Scalars['Int'],
  rank: Scalars['Int']
};


export type GetRecentTopicQuery = (
  { __typename?: 'Query' }
  & { recentTopic: (
    { __typename?: 'RecentTopicObject' }
    & { topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id' | 'title' | 'description'>
    )>, explanation: Maybe<(
      { __typename?: 'CardObject' }
      & Pick<CardObject, 'id' | 'explanationRules'>
      & { course: Maybe<(
        { __typename?: 'CourseObject' }
        & Pick<CourseObject, 'id'>
      )>, topic: Maybe<(
        { __typename?: 'TopicObject' }
        & Pick<TopicObject, 'id'>
      )> }
    )>, cards: Array<(
      { __typename?: 'CardObject' }
      & Pick<CardObject, 'id' | 'exampleSentence2'>
    )> }
  ) }
);

export type RecentExplanationsQueryVariables = {
  topic: Scalars['Int']
};


export type RecentExplanationsQuery = (
  { __typename?: 'Query' }
  & { recentExplanations: Array<(
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules'>
    & { course: Maybe<(
      { __typename?: 'CourseObject' }
      & Pick<CourseObject, 'id'>
    )>, topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id'>
    )> }
  )> }
);

export type ReleaseMnemoCardsQueryVariables = {
  courseId: Scalars['Int']
};


export type ReleaseMnemoCardsQuery = (
  { __typename?: 'Query' }
  & { unreleasedMnemos: Array<(
    { __typename?: 'CardObject' }
    & ExtendedCardFragment
  )> }
);

export type SearchCardsQueryVariables = {
  word?: Maybe<Scalars['String']>,
  content?: Maybe<Scalars['String']>,
  courseId?: Maybe<Scalars['Int']>
};


export type SearchCardsQuery = (
  { __typename?: 'Query' }
  & { searchCards: Array<(
    { __typename?: 'IndexedCardObject' }
    & Pick<IndexedCardObject, 'id' | 'sourceLemma' | 'translationId' | 'translationLemma' | 'wordRank' | 'topicTitle' | 'exerciseRules' | 'explanationRules' | 'relatedExplanationId' | 'exerciseTitle' | 'explanationTitle'>
  )> }
);

export type TopicExercisesQueryVariables = {
  topic: Scalars['Int']
};


export type TopicExercisesQuery = (
  { __typename?: 'Query' }
  & { topicExercises: Array<(
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules' | 'falseAnswers' | 'exerciseTranslation' | 'infinitivesOnly'>
    & { explanation: Maybe<(
      { __typename?: 'CardObject' }
      & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules'>
      & { course: Maybe<(
        { __typename?: 'CourseObject' }
        & Pick<CourseObject, 'id'>
      )>, topic: Maybe<(
        { __typename?: 'TopicObject' }
        & Pick<TopicObject, 'id' | 'title' | 'description'>
      )> }
    )> }
  )> }
);

export type TopicExplanationsQueryVariables = {
  topic: Scalars['Int']
};


export type TopicExplanationsQuery = (
  { __typename?: 'Query' }
  & { topicExplanations: Array<(
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'postTitle' | 'explanationRules'>
    & { topic: Maybe<(
      { __typename?: 'TopicObject' }
      & Pick<TopicObject, 'id' | 'title' | 'description'>
    )> }
  )> }
);

export type GetVocabularyCardByIdQueryVariables = {
  id: Scalars['Int']
};


export type GetVocabularyCardByIdQuery = (
  { __typename?: 'Query' }
  & { card: (
    { __typename?: 'CardObject' }
    & Pick<CardObject, 'id' | 'infinitivesOnly' | 'infinitivesOnly2' | 'sentenceAudio' | 'sentenceAudio2' | 'exampleSentenceTranslation' | 'exampleSentenceTranslation2' | 'exampleSentence' | 'exampleSentence2' | 'counterQuotaExplanation1' | 'counterQuotaExplanation2' | 'quotaExplanation1' | 'quotaExplanation2' | 'info' | 'infoDisapproveComment' | 'derivableFromWords' | 'postAuthorName' | 'approvingName' | 'reviewDescription' | 'editingRequiredAt' | 'editingRequiredComment'>
    & { course: Maybe<(
      { __typename?: 'CourseObject' }
      & Pick<CourseObject, 'id'>
      & { sourceLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id'>
      )>, translationLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id'>
      )> }
    )>, wordTranslation: Maybe<(
      { __typename?: 'WordTranslationObject' }
      & Pick<WordTranslationObject, 'id' | 'audio' | 'separateMeanings'>
      & { sourceLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id' | 'name'>
      )>, translationLanguage: Maybe<(
        { __typename?: 'LanguageObject' }
        & Pick<LanguageObject, 'id' | 'name'>
      )>, translationWord: Maybe<(
        { __typename?: 'WordObject' }
        & Pick<WordObject, 'id' | 'lemma'>
      )>, sourceWord: Maybe<(
        { __typename?: 'WordObject' }
        & Pick<WordObject, 'id' | 'lemma' | 'rank' | 'pos' | 'posDefinition'>
      )> }
    )> }
  ) }
);

export type GetAllowedCoursesQueryVariables = {
  userId?: Maybe<Scalars['Int']>
};


export type GetAllowedCoursesQuery = (
  { __typename?: 'Query' }
  & { allowedCourses: Array<(
    { __typename?: 'CourseObject' }
    & Pick<CourseObject, 'id'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name' | 'code'>
    )>, translationLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name' | 'code'>
    )> }
  )> }
);

export type AllCoursesQueryVariables = {};


export type AllCoursesQuery = (
  { __typename?: 'Query' }
  & { courses: Array<(
    { __typename?: 'CourseObject' }
    & CourseDetailsFragment
  )> }
);

export type CourseDetailsFragment = (
  { __typename?: 'CourseObject' }
  & Pick<CourseObject, 'id' | 'title'>
  & { sourceLanguage: Maybe<(
    { __typename?: 'LanguageObject' }
    & Pick<LanguageObject, 'name'>
  )>, translationLanguage: Maybe<(
    { __typename?: 'LanguageObject' }
    & Pick<LanguageObject, 'name'>
  )> }
);

export type LanguageCoursesQueryVariables = {
  languageId: Scalars['Int']
};


export type LanguageCoursesQuery = (
  { __typename?: 'Query' }
  & { coursesByLanguage: Array<(
    { __typename?: 'CourseObject' }
    & Pick<CourseObject, 'id' | 'title'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, translationLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, stages: Array<(
      { __typename?: 'StageObject' }
      & Pick<StageObject, 'id' | 'level' | 'countExplanationCards'>
      & { topics: Array<(
        { __typename?: 'TopicObject' }
        & Pick<TopicObject, 'id' | 'title'>
      )> }
    )> }
  )> }
);

export type GetNextCardUrlQueryVariables = {
  courseId: Scalars['Int'],
  role: Scalars['String'],
  backToStream?: Maybe<Scalars['Int']>
};


export type GetNextCardUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'nextCardUrl'>
);

export type HelloQueryVariables = {
  name: Scalars['String']
};


export type HelloQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'hello'>
);

export type LanguagesQueryVariables = {};


export type LanguagesQuery = (
  { __typename?: 'Query' }
  & { languages: Array<(
    { __typename?: 'LanguageObject' }
    & Pick<LanguageObject, 'id' | 'name' | 'code'>
  )> }
);

export type LegQueryVariables = {
  id: Scalars['Int']
};


export type LegQuery = (
  { __typename?: 'Query' }
  & { leg: (
    { __typename?: 'LegObject' }
    & Pick<LegObject, 'id' | 'postTitle' | 'position' | 'popupPicture' | 'popupPictureId' | 'image' | 'imageId' | 'imagePortrait' | 'imagePortraitId'>
  ) }
);

export type LegsQueryVariables = {
  stage: Scalars['Int']
};


export type LegsQuery = (
  { __typename?: 'Query' }
  & { stageLegs: Array<(
    { __typename?: 'LegObject' }
    & Pick<LegObject, 'id' | 'postTitle' | 'position' | 'popupPicture' | 'image' | 'imagePortrait'>
  )> }
);

export type OptimizedAudioAvailableQueryVariables = {
  id: Scalars['Int'],
  fileUrl: Scalars['String'],
  noTimeout?: Maybe<Scalars['Boolean']>
};


export type OptimizedAudioAvailableQuery = (
  { __typename?: 'Query' }
  & { optimizedAudioAvailable: (
    { __typename?: 'OptimizedAudioObject' }
    & Pick<OptimizedAudioObject, 'id' | 'url' | 'status' | 'message'>
  ) }
);

export type GetQuotaCheckQueryVariables = {
  excludedWords: Array<Scalars['String']>,
  values: Array<Scalars['String']>,
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int']
};


export type GetQuotaCheckQuery = (
  { __typename?: 'Query' }
  & { quotaCheck: (
    { __typename?: 'QuotaObject' }
    & Pick<QuotaObject, 'success' | 'content' | 'valid' | 'quotaData'>
  ) }
);

export type SearchAlreadyCreatedCardsQueryVariables = {
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int'],
  query: Scalars['String']
};


export type SearchAlreadyCreatedCardsQuery = (
  { __typename?: 'Query' }
  & { searchAlreadyCreatedCards: Array<(
    { __typename?: 'AutocompleteEntryObject' }
    & Pick<AutocompleteEntryObject, 'id' | 'text'>
  )> }
);

export type SearchTranslationsQueryVariables = {
  sourceLanguage: Scalars['Int'],
  translationLanguage: Scalars['Int'],
  query: Scalars['String']
};


export type SearchTranslationsQuery = (
  { __typename?: 'Query' }
  & { searchTranslations: Array<(
    { __typename?: 'AutocompleteEntryObject' }
    & Pick<AutocompleteEntryObject, 'id' | 'text'>
  )> }
);

export type GetStageForCourseQueryVariables = {
  courseId: Scalars['Int']
};


export type GetStageForCourseQuery = (
  { __typename?: 'Query' }
  & { stageForCourse: (
    { __typename?: 'StageObject' }
    & Pick<StageObject, 'id'>
  ) }
);

export type CardsPerDayQueryVariables = {
  role: Scalars['String']
};


export type CardsPerDayQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'cardsPerDay'>
);

export type LpExtendedStatsQueryVariables = {
  my?: Maybe<Scalars['Boolean']>,
  userId?: Maybe<Scalars['Int']>,
  periods: Array<PeriodItemInput>
};


export type LpExtendedStatsQuery = (
  { __typename?: 'Query' }
  & { stats: Array<(
    { __typename?: 'PeriodStatsObject' }
    & Pick<PeriodStatsObject, 'period'>
    & { details: Maybe<(
      { __typename?: 'StatsObject' }
      & LpExtendedStatsFragmentFragment
    )> }
  )> }
);

export type LpExtendedStatsFragmentFragment = (
  { __typename?: 'StatsObject' }
  & Pick<StatsObject, 'totalQs' | 'vocabularyQs' | 'exerciseQs' | 'reviewQs' | 'cardsPerDay'>
);

export type LpStatsQueryVariables = {
  my?: Maybe<Scalars['Boolean']>,
  userId?: Maybe<Scalars['Int']>,
  periods: Array<PeriodItemInput>
};


export type LpStatsQuery = (
  { __typename?: 'Query' }
  & { stats: Array<(
    { __typename?: 'PeriodStatsObject' }
    & Pick<PeriodStatsObject, 'period'>
    & { details: Maybe<(
      { __typename?: 'StatsObject' }
      & LpStatsFragmentFragment
    )> }
  )> }
);

export type LpStatsFragmentFragment = (
  { __typename?: 'StatsObject' }
  & Pick<StatsObject, 'vocabularyCreated' | 'totalReviewed' | 'totalEscalated' | 'exerciseCreated'>
);

export type McStatsQueryVariables = {
  my?: Maybe<Scalars['Boolean']>,
  userId?: Maybe<Scalars['Int']>,
  periods: Array<PeriodItemInput>
};


export type McStatsQuery = (
  { __typename?: 'Query' }
  & { stats: Array<(
    { __typename?: 'PeriodStatsObject' }
    & Pick<PeriodStatsObject, 'period'>
    & { details: Maybe<(
      { __typename?: 'StatsObject' }
      & McStatsFragmentFragment
    )> }
  )> }
);

export type McStatsFragmentFragment = (
  { __typename?: 'StatsObject' }
  & Pick<StatsObject, 'mnemoCreated' | 'mnemoReviewed' | 'mnemoEscalated'>
);

export type MeStatsQueryVariables = {
  my?: Maybe<Scalars['Boolean']>,
  userId?: Maybe<Scalars['Int']>,
  periods: Array<PeriodItemInput>
};


export type MeStatsQuery = (
  { __typename?: 'Query' }
  & { stats: Array<(
    { __typename?: 'PeriodStatsObject' }
    & Pick<PeriodStatsObject, 'period'>
    & { details: Maybe<(
      { __typename?: 'StatsObject' }
      & MeStatsFragmentFragment
    )> }
  )> }
);

export type MeStatsFragmentFragment = (
  { __typename?: 'StatsObject' }
  & Pick<StatsObject, 'mediaCreated' | 'mediaGood' | 'mediaGoodPercent' | 'mediaReviewed' | 'mediaEscalated'>
);

export type RolesListQueryVariables = {
  role: Scalars['String'],
  courseId?: Maybe<Scalars['Int']>
};


export type RolesListQuery = (
  { __typename?: 'Query' }
  & { rolesList: Array<(
    { __typename?: 'CreatorObject' }
    & Pick<CreatorObject, 'id' | 'name' | 'registered' | 'allowedCourses'>
    & { stats: Maybe<(
      { __typename?: 'PeriodStatsObject' }
      & Pick<PeriodStatsObject, 'period'>
      & { details: Maybe<(
        { __typename?: 'StatsObject' }
        & LpExtendedStatsFragmentFragment
        & McStatsFragmentFragment
        & MeStatsFragmentFragment
      )> }
    )> }
  )> }
);

export type SearchTopicsQueryVariables = {
  query: Scalars['String']
};


export type SearchTopicsQuery = (
  { __typename?: 'Query' }
  & { searchTopics: Array<(
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id' | 'title'>
  )> }
);

export type TopicQueryVariables = {
  id: Scalars['Int']
};


export type TopicQuery = (
  { __typename?: 'Query' }
  & { topic: (
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id' | 'title' | 'description' | 'relatedTopics'>
    & { stage: Maybe<(
      { __typename?: 'StageObject' }
      & Pick<StageObject, 'id' | 'level'>
      & { course: Maybe<(
        { __typename?: 'CourseObject' }
        & Pick<CourseObject, 'id'>
        & { sourceLanguage: Maybe<(
          { __typename?: 'LanguageObject' }
          & Pick<LanguageObject, 'id' | 'name'>
        )>, translationLanguage: Maybe<(
          { __typename?: 'LanguageObject' }
          & Pick<LanguageObject, 'id' | 'name'>
        )> }
      )> }
    )> }
  ) }
);

export type TopicsByIdsQueryVariables = {
  ids: Array<Scalars['Int']>
};


export type TopicsByIdsQuery = (
  { __typename?: 'Query' }
  & { topicsByIds: Array<(
    { __typename?: 'TopicObject' }
    & Pick<TopicObject, 'id' | 'title'>
  )> }
);

export type GetTranslationForVocabularyQueryVariables = {
  id: Scalars['Int']
};


export type GetTranslationForVocabularyQuery = (
  { __typename?: 'Query' }
  & { wordTranslation: (
    { __typename?: 'WordTranslationObject' }
    & Pick<WordTranslationObject, 'id' | 'audio'>
    & { sourceLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, translationLanguage: Maybe<(
      { __typename?: 'LanguageObject' }
      & Pick<LanguageObject, 'id' | 'name'>
    )>, translationWord: Maybe<(
      { __typename?: 'WordObject' }
      & Pick<WordObject, 'id' | 'lemma'>
    )>, sourceWord: Maybe<(
      { __typename?: 'WordObject' }
      & Pick<WordObject, 'id' | 'lemma' | 'rank' | 'pos' | 'posDefinition' | 'predefinedComment'>
      & { predefinedTranslation: Maybe<(
        { __typename?: 'WordTranslationObject' }
        & Pick<WordTranslationObject, 'id'>
      )> }
    )> }
  ) }
);

export type AddSubscriptionMutationVariables = {
  userId: Scalars['Int'],
  courseId?: Maybe<Scalars['Int']>,
  all?: Maybe<Scalars['Boolean']>,
  removeAll?: Maybe<Scalars['Boolean']>
};


export type AddSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSubscription'>
);

export type AllUsersQueryVariables = {
  roles?: Maybe<Array<Scalars['String']>>
};


export type AllUsersQuery = (
  { __typename?: 'Query' }
  & { allUsers: Array<(
    { __typename?: 'UserObject' }
    & Pick<UserObject, 'id' | 'email' | 'firstName' | 'lastName'>
  )> }
);

export type UserDetailsFragment = (
  { __typename?: 'UserObject' }
  & Pick<UserObject, 'id' | 'email' | 'name' | 'userLogin' | 'roles'>
);

export type MeQueryVariables = {};


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserObject' }
    & UserDetailsFragment
  ) }
);

export type SearchUserByEmailQueryVariables = {
  email: Scalars['String']
};


export type SearchUserByEmailQuery = (
  { __typename?: 'Query' }
  & { user: Maybe<(
    { __typename?: 'UserAdminObject' }
    & Pick<UserAdminObject, 'id' | 'email' | 'emailConfirmed' | 'allCoursesEnabled' | 'coursesEnabled' | 'firstName' | 'lastName' | 'registered'>
    & { courses: Array<(
      { __typename?: 'UserCourseObject' }
      & Pick<UserCourseObject, 'id' | 'name' | 'nextVocabulary' | 'finished' | 'isAvailable'>
    )> }
  )> }
);

export type UserByIdQueryVariables = {
  id: Scalars['Int']
};


export type UserByIdQuery = (
  { __typename?: 'Query' }
  & { user: (
    { __typename?: 'UserObject' }
    & UserDetailsFragment
  ) }
);

export type MaskFragmentFragment = (
  { __typename?: 'WordMaskObject' }
  & Pick<WordMaskObject, 'id' | 'word' | 'rank'>
);

export type MasksQueryVariables = {
  courseId: Scalars['Int'],
  rank: Scalars['Int']
};


export type MasksQuery = (
  { __typename?: 'Query' }
  & { nouns: Array<(
    { __typename?: 'WordMaskObject' }
    & MaskFragmentFragment
  )>, adjectives: Array<(
    { __typename?: 'WordMaskObject' }
    & MaskFragmentFragment
  )>, verbs: Array<(
    { __typename?: 'WordMaskObject' }
    & MaskFragmentFragment
  )>, other: Array<(
    { __typename?: 'WordMaskObject' }
    & MaskFragmentFragment
  )> }
);

export type GetWordByIdQueryVariables = {
  id: Scalars['Int']
};


export type GetWordByIdQuery = (
  { __typename?: 'Query' }
  & { word: (
    { __typename?: 'WordObject' }
    & Pick<WordObject, 'id' | 'lemma'>
    & { predefinedTranslation: Maybe<(
      { __typename?: 'WordTranslationObject' }
      & Pick<WordTranslationObject, 'id'>
    )> }
  ) }
);

export const ExtendedCardFragmentDoc = gql`
    fragment ExtendedCard on CardObject {
  id
  postTitle
  cardType
  creatorName
  approvingName
  escalatingName
  approvedAt
  disapprovedAt
  feedback
  falseAnswers
  explanationRules
  infinitivesOnly
  infinitivesOnly2
  reviewDescription
  exerciseTranslation
  exampleSentence
  exampleSentenceOriginal
  exampleSentence2
  exampleSentence2Original
  exampleSentenceTranslation
  exampleSentenceTranslationOriginal
  exampleSentenceTranslation2
  exampleSentenceTranslation2Original
  sentenceAudio
  sentenceAudioOriginal
  sentenceAudio2
  sentenceAudio2Original
  info
  editingRequiredAt
  editingRequiredComment
  derivableFromWords
  escalationWasCorrect
  escalationWasIncorrect
  reviewedAt
  explanation {
    id
    postTitle
    explanationRules
    topic {
      id
      title
      description
    }
    course {
      id
      title
    }
  }
  stage {
    level
  }
  topic {
    id
    title
    description
  }
  course {
    id
    sourceLanguage {
      id
      code
      name
    }
    translationLanguage {
      id
      code
      name
    }
  }
  wordTranslation {
    id
    audio
    sourceLanguage {
      id
      name
    }
    translationLanguage {
      id
      name
    }
    separateMeanings
    translationWord {
      id
      lemma
    }
    sourceWord {
      id
      lemma
      rank
      pos
      posDefinition
    }
  }
  mnemo {
    feedback
    mnemoKeyword
    shortSentence
    sentence
    approvingName
    approvedAt
    disapprovedAt
    escalatingName
    disapproveComment
    postAuthorName
  }
}
    `;
export const CourseDetailsFragmentDoc = gql`
    fragment CourseDetails on CourseObject {
  id
  title
  sourceLanguage {
    name
  }
  translationLanguage {
    name
  }
}
    `;
export const LpExtendedStatsFragmentFragmentDoc = gql`
    fragment LpExtendedStatsFragment on StatsObject {
  totalQs
  vocabularyQs
  exerciseQs
  reviewQs
  cardsPerDay
}
    `;
export const LpStatsFragmentFragmentDoc = gql`
    fragment LpStatsFragment on StatsObject {
  vocabularyCreated
  totalReviewed
  totalEscalated
  exerciseCreated
}
    `;
export const McStatsFragmentFragmentDoc = gql`
    fragment McStatsFragment on StatsObject {
  mnemoCreated
  mnemoReviewed
  mnemoEscalated
}
    `;
export const MeStatsFragmentFragmentDoc = gql`
    fragment MeStatsFragment on StatsObject {
  mediaCreated
  mediaGood
  mediaGoodPercent
  mediaReviewed
  mediaEscalated
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on UserObject {
  id
  email
  name
  userLogin
  roles
}
    `;
export const MaskFragmentFragmentDoc = gql`
    fragment MaskFragment on WordMaskObject {
  id
  word
  rank
}
    `;
export const CreateAchievementDocument = gql`
    mutation CreateAchievement($data: UpdateAchievementInput!) {
  createAchievement(input: $data) {
    id
  }
}
    `;
export type CreateAchievementMutationFn = ApolloReactCommon.MutationFunction<CreateAchievementMutation, CreateAchievementMutationVariables>;
export type CreateAchievementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAchievementMutation, CreateAchievementMutationVariables>, 'mutation'>;

    export const CreateAchievementComponent = (props: CreateAchievementComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAchievementMutation, CreateAchievementMutationVariables> mutation={CreateAchievementDocument} {...props} />
    );
    

/**
 * __useCreateAchievementMutation__
 *
 * To run a mutation, you first call `useCreateAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAchievementMutation, { data, loading, error }] = useCreateAchievementMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAchievementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAchievementMutation, CreateAchievementMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateAchievementMutation, CreateAchievementMutationVariables>(CreateAchievementDocument, baseOptions);
      }
export type CreateAchievementMutationHookResult = ReturnType<typeof useCreateAchievementMutation>;
export type CreateAchievementMutationResult = ApolloReactCommon.MutationResult<CreateAchievementMutation>;
export type CreateAchievementMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAchievementMutation, CreateAchievementMutationVariables>;
export const UpdateAchievementDocument = gql`
    mutation UpdateAchievement($id: Int!, $data: UpdateAchievementInput!) {
  updateAchievement(id: $id, input: $data) {
    id
  }
}
    `;
export type UpdateAchievementMutationFn = ApolloReactCommon.MutationFunction<UpdateAchievementMutation, UpdateAchievementMutationVariables>;
export type UpdateAchievementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAchievementMutation, UpdateAchievementMutationVariables>, 'mutation'>;

    export const UpdateAchievementComponent = (props: UpdateAchievementComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAchievementMutation, UpdateAchievementMutationVariables> mutation={UpdateAchievementDocument} {...props} />
    );
    

/**
 * __useUpdateAchievementMutation__
 *
 * To run a mutation, you first call `useUpdateAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAchievementMutation, { data, loading, error }] = useUpdateAchievementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAchievementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAchievementMutation, UpdateAchievementMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAchievementMutation, UpdateAchievementMutationVariables>(UpdateAchievementDocument, baseOptions);
      }
export type UpdateAchievementMutationHookResult = ReturnType<typeof useUpdateAchievementMutation>;
export type UpdateAchievementMutationResult = ApolloReactCommon.MutationResult<UpdateAchievementMutation>;
export type UpdateAchievementMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAchievementMutation, UpdateAchievementMutationVariables>;
export const CreateCardDocument = gql`
    mutation CreateCard($input: UpdateCardInput!) {
  createCard(input: $input) {
    id
  }
}
    `;
export type CreateCardMutationFn = ApolloReactCommon.MutationFunction<CreateCardMutation, CreateCardMutationVariables>;
export type CreateCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCardMutation, CreateCardMutationVariables>, 'mutation'>;

    export const CreateCardComponent = (props: CreateCardComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCardMutation, CreateCardMutationVariables> mutation={CreateCardDocument} {...props} />
    );
    

/**
 * __useCreateCardMutation__
 *
 * To run a mutation, you first call `useCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardMutation, { data, loading, error }] = useCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCardMutation, CreateCardMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCardMutation, CreateCardMutationVariables>(CreateCardDocument, baseOptions);
      }
export type CreateCardMutationHookResult = ReturnType<typeof useCreateCardMutation>;
export type CreateCardMutationResult = ApolloReactCommon.MutationResult<CreateCardMutation>;
export type CreateCardMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCardMutation, CreateCardMutationVariables>;
export const ReleaseMnemosDocument = gql`
    mutation ReleaseMnemos($data: [ReleaseInputInput!]!) {
  releaseMnemos(items: $data)
}
    `;
export type ReleaseMnemosMutationFn = ApolloReactCommon.MutationFunction<ReleaseMnemosMutation, ReleaseMnemosMutationVariables>;
export type ReleaseMnemosComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReleaseMnemosMutation, ReleaseMnemosMutationVariables>, 'mutation'>;

    export const ReleaseMnemosComponent = (props: ReleaseMnemosComponentProps) => (
      <ApolloReactComponents.Mutation<ReleaseMnemosMutation, ReleaseMnemosMutationVariables> mutation={ReleaseMnemosDocument} {...props} />
    );
    

/**
 * __useReleaseMnemosMutation__
 *
 * To run a mutation, you first call `useReleaseMnemosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseMnemosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseMnemosMutation, { data, loading, error }] = useReleaseMnemosMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReleaseMnemosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReleaseMnemosMutation, ReleaseMnemosMutationVariables>) {
        return ApolloReactHooks.useMutation<ReleaseMnemosMutation, ReleaseMnemosMutationVariables>(ReleaseMnemosDocument, baseOptions);
      }
export type ReleaseMnemosMutationHookResult = ReturnType<typeof useReleaseMnemosMutation>;
export type ReleaseMnemosMutationResult = ApolloReactCommon.MutationResult<ReleaseMnemosMutation>;
export type ReleaseMnemosMutationOptions = ApolloReactCommon.BaseMutationOptions<ReleaseMnemosMutation, ReleaseMnemosMutationVariables>;
export const UpdateCardDocument = gql`
    mutation UpdateCard($id: Int!, $input: UpdateCardInput!, $editMode: Boolean) {
  updateCard(id: $id, input: $input, editMode: $editMode) {
    id
  }
}
    `;
export type UpdateCardMutationFn = ApolloReactCommon.MutationFunction<UpdateCardMutation, UpdateCardMutationVariables>;
export type UpdateCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCardMutation, UpdateCardMutationVariables>, 'mutation'>;

    export const UpdateCardComponent = (props: UpdateCardComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCardMutation, UpdateCardMutationVariables> mutation={UpdateCardDocument} {...props} />
    );
    

/**
 * __useUpdateCardMutation__
 *
 * To run a mutation, you first call `useUpdateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardMutation, { data, loading, error }] = useUpdateCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      editMode: // value for 'editMode'
 *   },
 * });
 */
export function useUpdateCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCardMutation, UpdateCardMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCardMutation, UpdateCardMutationVariables>(UpdateCardDocument, baseOptions);
      }
export type UpdateCardMutationHookResult = ReturnType<typeof useUpdateCardMutation>;
export type UpdateCardMutationResult = ApolloReactCommon.MutationResult<UpdateCardMutation>;
export type UpdateCardMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCardMutation, UpdateCardMutationVariables>;
export const UpdateMnemoDocument = gql`
    mutation UpdateMnemo($id: Int!, $input: UpdateMnemoInput!) {
  updateMnemo(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateMnemoMutationFn = ApolloReactCommon.MutationFunction<UpdateMnemoMutation, UpdateMnemoMutationVariables>;
export type UpdateMnemoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMnemoMutation, UpdateMnemoMutationVariables>, 'mutation'>;

    export const UpdateMnemoComponent = (props: UpdateMnemoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMnemoMutation, UpdateMnemoMutationVariables> mutation={UpdateMnemoDocument} {...props} />
    );
    

/**
 * __useUpdateMnemoMutation__
 *
 * To run a mutation, you first call `useUpdateMnemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMnemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMnemoMutation, { data, loading, error }] = useUpdateMnemoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMnemoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMnemoMutation, UpdateMnemoMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMnemoMutation, UpdateMnemoMutationVariables>(UpdateMnemoDocument, baseOptions);
      }
export type UpdateMnemoMutationHookResult = ReturnType<typeof useUpdateMnemoMutation>;
export type UpdateMnemoMutationResult = ApolloReactCommon.MutationResult<UpdateMnemoMutation>;
export type UpdateMnemoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMnemoMutation, UpdateMnemoMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($input: UpdateCourseInput!) {
  createCourse(input: $input) {
    id
  }
}
    `;
export type CreateCourseMutationFn = ApolloReactCommon.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;
export type CreateCourseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateCourseMutation, CreateCourseMutationVariables>, 'mutation'>;

    export const CreateCourseComponent = (props: CreateCourseComponentProps) => (
      <ApolloReactComponents.Mutation<CreateCourseMutation, CreateCourseMutationVariables> mutation={CreateCourseDocument} {...props} />
    );
    

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, baseOptions);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = ApolloReactCommon.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($id: Int!, $input: UpdateCourseInput!) {
  updateCourse(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateCourseMutationFn = ApolloReactCommon.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;
export type UpdateCourseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCourseMutation, UpdateCourseMutationVariables>, 'mutation'>;

    export const UpdateCourseComponent = (props: UpdateCourseComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCourseMutation, UpdateCourseMutationVariables> mutation={UpdateCourseDocument} {...props} />
    );
    

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, baseOptions);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = ApolloReactCommon.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const CreateLegDocument = gql`
    mutation CreateLeg($input: UpdateLegInput!) {
  createLeg(input: $input) {
    id
  }
}
    `;
export type CreateLegMutationFn = ApolloReactCommon.MutationFunction<CreateLegMutation, CreateLegMutationVariables>;
export type CreateLegComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateLegMutation, CreateLegMutationVariables>, 'mutation'>;

    export const CreateLegComponent = (props: CreateLegComponentProps) => (
      <ApolloReactComponents.Mutation<CreateLegMutation, CreateLegMutationVariables> mutation={CreateLegDocument} {...props} />
    );
    

/**
 * __useCreateLegMutation__
 *
 * To run a mutation, you first call `useCreateLegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegMutation, { data, loading, error }] = useCreateLegMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLegMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLegMutation, CreateLegMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateLegMutation, CreateLegMutationVariables>(CreateLegDocument, baseOptions);
      }
export type CreateLegMutationHookResult = ReturnType<typeof useCreateLegMutation>;
export type CreateLegMutationResult = ApolloReactCommon.MutationResult<CreateLegMutation>;
export type CreateLegMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLegMutation, CreateLegMutationVariables>;
export const UpdateLegDocument = gql`
    mutation UpdateLeg($id: Int!, $input: UpdateLegInput!) {
  updateLeg(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateLegMutationFn = ApolloReactCommon.MutationFunction<UpdateLegMutation, UpdateLegMutationVariables>;
export type UpdateLegComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateLegMutation, UpdateLegMutationVariables>, 'mutation'>;

    export const UpdateLegComponent = (props: UpdateLegComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateLegMutation, UpdateLegMutationVariables> mutation={UpdateLegDocument} {...props} />
    );
    

/**
 * __useUpdateLegMutation__
 *
 * To run a mutation, you first call `useUpdateLegMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegMutation, { data, loading, error }] = useUpdateLegMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLegMutation, UpdateLegMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateLegMutation, UpdateLegMutationVariables>(UpdateLegDocument, baseOptions);
      }
export type UpdateLegMutationHookResult = ReturnType<typeof useUpdateLegMutation>;
export type UpdateLegMutationResult = ApolloReactCommon.MutationResult<UpdateLegMutation>;
export type UpdateLegMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateLegMutation, UpdateLegMutationVariables>;
export const CreateStageDocument = gql`
    mutation CreateStage($input: UpdateStageInput!) {
  createStage(input: $input) {
    id
    countExplanationCards
    level
    topics {
      id
    }
  }
}
    `;
export type CreateStageMutationFn = ApolloReactCommon.MutationFunction<CreateStageMutation, CreateStageMutationVariables>;
export type CreateStageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateStageMutation, CreateStageMutationVariables>, 'mutation'>;

    export const CreateStageComponent = (props: CreateStageComponentProps) => (
      <ApolloReactComponents.Mutation<CreateStageMutation, CreateStageMutationVariables> mutation={CreateStageDocument} {...props} />
    );
    

/**
 * __useCreateStageMutation__
 *
 * To run a mutation, you first call `useCreateStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStageMutation, { data, loading, error }] = useCreateStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStageMutation, CreateStageMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateStageMutation, CreateStageMutationVariables>(CreateStageDocument, baseOptions);
      }
export type CreateStageMutationHookResult = ReturnType<typeof useCreateStageMutation>;
export type CreateStageMutationResult = ApolloReactCommon.MutationResult<CreateStageMutation>;
export type CreateStageMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStageMutation, CreateStageMutationVariables>;
export const CreateTopicDocument = gql`
    mutation CreateTopic($input: UpdateTopicInput!) {
  createTopic(input: $input) {
    id
  }
}
    `;
export type CreateTopicMutationFn = ApolloReactCommon.MutationFunction<CreateTopicMutation, CreateTopicMutationVariables>;
export type CreateTopicComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateTopicMutation, CreateTopicMutationVariables>, 'mutation'>;

    export const CreateTopicComponent = (props: CreateTopicComponentProps) => (
      <ApolloReactComponents.Mutation<CreateTopicMutation, CreateTopicMutationVariables> mutation={CreateTopicDocument} {...props} />
    );
    

/**
 * __useCreateTopicMutation__
 *
 * To run a mutation, you first call `useCreateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicMutation, { data, loading, error }] = useCreateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTopicMutation, CreateTopicMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTopicMutation, CreateTopicMutationVariables>(CreateTopicDocument, baseOptions);
      }
export type CreateTopicMutationHookResult = ReturnType<typeof useCreateTopicMutation>;
export type CreateTopicMutationResult = ApolloReactCommon.MutationResult<CreateTopicMutation>;
export type CreateTopicMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTopicMutation, CreateTopicMutationVariables>;
export const UpdateTopicDocument = gql`
    mutation UpdateTopic($id: Int!, $input: UpdateTopicInput!) {
  updateTopic(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateTopicMutationFn = ApolloReactCommon.MutationFunction<UpdateTopicMutation, UpdateTopicMutationVariables>;
export type UpdateTopicComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateTopicMutation, UpdateTopicMutationVariables>, 'mutation'>;

    export const UpdateTopicComponent = (props: UpdateTopicComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateTopicMutation, UpdateTopicMutationVariables> mutation={UpdateTopicDocument} {...props} />
    );
    

/**
 * __useUpdateTopicMutation__
 *
 * To run a mutation, you first call `useUpdateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicMutation, { data, loading, error }] = useUpdateTopicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTopicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTopicMutation, UpdateTopicMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTopicMutation, UpdateTopicMutationVariables>(UpdateTopicDocument, baseOptions);
      }
export type UpdateTopicMutationHookResult = ReturnType<typeof useUpdateTopicMutation>;
export type UpdateTopicMutationResult = ApolloReactCommon.MutationResult<UpdateTopicMutation>;
export type UpdateTopicMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTopicMutation, UpdateTopicMutationVariables>;
export const CreateWordTranslationDocument = gql`
    mutation CreateWordTranslation($input: UpdateWordTranslationInput!) {
  createWordTranslation(input: $input) {
    id
  }
}
    `;
export type CreateWordTranslationMutationFn = ApolloReactCommon.MutationFunction<CreateWordTranslationMutation, CreateWordTranslationMutationVariables>;
export type CreateWordTranslationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateWordTranslationMutation, CreateWordTranslationMutationVariables>, 'mutation'>;

    export const CreateWordTranslationComponent = (props: CreateWordTranslationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateWordTranslationMutation, CreateWordTranslationMutationVariables> mutation={CreateWordTranslationDocument} {...props} />
    );
    

/**
 * __useCreateWordTranslationMutation__
 *
 * To run a mutation, you first call `useCreateWordTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWordTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWordTranslationMutation, { data, loading, error }] = useCreateWordTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWordTranslationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWordTranslationMutation, CreateWordTranslationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateWordTranslationMutation, CreateWordTranslationMutationVariables>(CreateWordTranslationDocument, baseOptions);
      }
export type CreateWordTranslationMutationHookResult = ReturnType<typeof useCreateWordTranslationMutation>;
export type CreateWordTranslationMutationResult = ApolloReactCommon.MutationResult<CreateWordTranslationMutation>;
export type CreateWordTranslationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWordTranslationMutation, CreateWordTranslationMutationVariables>;
export const UpdateWordTranslationDocument = gql`
    mutation UpdateWordTranslation($id: Int!, $input: UpdateWordTranslationInput!) {
  updateWordTranslation(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateWordTranslationMutationFn = ApolloReactCommon.MutationFunction<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables>;
export type UpdateWordTranslationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables>, 'mutation'>;

    export const UpdateWordTranslationComponent = (props: UpdateWordTranslationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables> mutation={UpdateWordTranslationDocument} {...props} />
    );
    

/**
 * __useUpdateWordTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateWordTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWordTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWordTranslationMutation, { data, loading, error }] = useUpdateWordTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWordTranslationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables>(UpdateWordTranslationDocument, baseOptions);
      }
export type UpdateWordTranslationMutationHookResult = ReturnType<typeof useUpdateWordTranslationMutation>;
export type UpdateWordTranslationMutationResult = ApolloReactCommon.MutationResult<UpdateWordTranslationMutation>;
export type UpdateWordTranslationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWordTranslationMutation, UpdateWordTranslationMutationVariables>;
export const UpdateMetaDocument = gql`
    mutation UpdateMeta($userId: Int!, $key: String!, $value: String!) {
  updateMeta(userId: $userId, key: $key, value: $value)
}
    `;
export type UpdateMetaMutationFn = ApolloReactCommon.MutationFunction<UpdateMetaMutation, UpdateMetaMutationVariables>;
export type UpdateMetaComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMetaMutation, UpdateMetaMutationVariables>, 'mutation'>;

    export const UpdateMetaComponent = (props: UpdateMetaComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMetaMutation, UpdateMetaMutationVariables> mutation={UpdateMetaDocument} {...props} />
    );
    

/**
 * __useUpdateMetaMutation__
 *
 * To run a mutation, you first call `useUpdateMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaMutation, { data, loading, error }] = useUpdateMetaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateMetaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMetaMutation, UpdateMetaMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMetaMutation, UpdateMetaMutationVariables>(UpdateMetaDocument, baseOptions);
      }
export type UpdateMetaMutationHookResult = ReturnType<typeof useUpdateMetaMutation>;
export type UpdateMetaMutationResult = ApolloReactCommon.MutationResult<UpdateMetaMutation>;
export type UpdateMetaMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMetaMutation, UpdateMetaMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: Int!, $email: String, $firstName: String, $lastName: String) {
  updateUser(userId: $userId, email: $email, firstName: $firstName, lastName: $lastName)
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateUserMutation, UpdateUserMutationVariables>, 'mutation'>;

    export const UpdateUserComponent = (props: UpdateUserComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateUserMutation, UpdateUserMutationVariables> mutation={UpdateUserDocument} {...props} />
    );
    

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateWordDocument = gql`
    mutation CreateWord($input: UpdateWordInput!) {
  createWord(input: $input) {
    id
    lemma
  }
}
    `;
export type CreateWordMutationFn = ApolloReactCommon.MutationFunction<CreateWordMutation, CreateWordMutationVariables>;
export type CreateWordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateWordMutation, CreateWordMutationVariables>, 'mutation'>;

    export const CreateWordComponent = (props: CreateWordComponentProps) => (
      <ApolloReactComponents.Mutation<CreateWordMutation, CreateWordMutationVariables> mutation={CreateWordDocument} {...props} />
    );
    

/**
 * __useCreateWordMutation__
 *
 * To run a mutation, you first call `useCreateWordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWordMutation, { data, loading, error }] = useCreateWordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWordMutation, CreateWordMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateWordMutation, CreateWordMutationVariables>(CreateWordDocument, baseOptions);
      }
export type CreateWordMutationHookResult = ReturnType<typeof useCreateWordMutation>;
export type CreateWordMutationResult = ApolloReactCommon.MutationResult<CreateWordMutation>;
export type CreateWordMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWordMutation, CreateWordMutationVariables>;
export const AchievementDocument = gql`
    query Achievement($id: Int!) {
  achievement(id: $id) {
    id
    description
    imageId
    image
    type
    position
    sourceLanguage {
      id
    }
  }
}
    `;
export type AchievementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AchievementQuery, AchievementQueryVariables>, 'query'> & ({ variables: AchievementQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AchievementComponent = (props: AchievementComponentProps) => (
      <ApolloReactComponents.Query<AchievementQuery, AchievementQueryVariables> query={AchievementDocument} {...props} />
    );
    

/**
 * __useAchievementQuery__
 *
 * To run a query within a React component, call `useAchievementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAchievementQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAchievementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAchievementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AchievementQuery, AchievementQueryVariables>) {
        return ApolloReactHooks.useQuery<AchievementQuery, AchievementQueryVariables>(AchievementDocument, baseOptions);
      }
export function useAchievementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AchievementQuery, AchievementQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AchievementQuery, AchievementQueryVariables>(AchievementDocument, baseOptions);
        }
export type AchievementQueryHookResult = ReturnType<typeof useAchievementQuery>;
export type AchievementLazyQueryHookResult = ReturnType<typeof useAchievementLazyQuery>;
export type AchievementQueryResult = ApolloReactCommon.QueryResult<AchievementQuery, AchievementQueryVariables>;
export const ProgressAchievementsDocument = gql`
    query ProgressAchievements($language: Int!) {
  progressAchievements(languageId: $language) {
    id
    description
    imageId
    image
    type
    position
  }
}
    `;
export type ProgressAchievementsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>, 'query'> & ({ variables: ProgressAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProgressAchievementsComponent = (props: ProgressAchievementsComponentProps) => (
      <ApolloReactComponents.Query<ProgressAchievementsQuery, ProgressAchievementsQueryVariables> query={ProgressAchievementsDocument} {...props} />
    );
    

/**
 * __useProgressAchievementsQuery__
 *
 * To run a query within a React component, call `useProgressAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgressAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgressAchievementsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useProgressAchievementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>) {
        return ApolloReactHooks.useQuery<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>(ProgressAchievementsDocument, baseOptions);
      }
export function useProgressAchievementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>(ProgressAchievementsDocument, baseOptions);
        }
export type ProgressAchievementsQueryHookResult = ReturnType<typeof useProgressAchievementsQuery>;
export type ProgressAchievementsLazyQueryHookResult = ReturnType<typeof useProgressAchievementsLazyQuery>;
export type ProgressAchievementsQueryResult = ApolloReactCommon.QueryResult<ProgressAchievementsQuery, ProgressAchievementsQueryVariables>;
export const AnswersListDocument = gql`
    query AnswersList($userId: Int!) {
  answersList(userId: $userId) {
    log
    state
    date
    nextShow
    isSkipped
    selfEvaluation
    card {
      id
      cardType
      postTitle
      wordTranslation {
        sourceWord {
          lemma
        }
      }
    }
  }
}
    `;
export type AnswersListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AnswersListQuery, AnswersListQueryVariables>, 'query'> & ({ variables: AnswersListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnswersListComponent = (props: AnswersListComponentProps) => (
      <ApolloReactComponents.Query<AnswersListQuery, AnswersListQueryVariables> query={AnswersListDocument} {...props} />
    );
    

/**
 * __useAnswersListQuery__
 *
 * To run a query within a React component, call `useAnswersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswersListQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswersListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAnswersListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AnswersListQuery, AnswersListQueryVariables>) {
        return ApolloReactHooks.useQuery<AnswersListQuery, AnswersListQueryVariables>(AnswersListDocument, baseOptions);
      }
export function useAnswersListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnswersListQuery, AnswersListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AnswersListQuery, AnswersListQueryVariables>(AnswersListDocument, baseOptions);
        }
export type AnswersListQueryHookResult = ReturnType<typeof useAnswersListQuery>;
export type AnswersListLazyQueryHookResult = ReturnType<typeof useAnswersListLazyQuery>;
export type AnswersListQueryResult = ApolloReactCommon.QueryResult<AnswersListQuery, AnswersListQueryVariables>;
export const CardsCountersDocument = gql`
    query CardsCounters($userId: Int, $languageId: Int!, $createdType: String!, $rejectedType: String!, $pendingType: String!, $pendingEscalationType: String!, $reviewedType: String!, $escalatedType: String!) {
  created: cardsList(userId: $userId, languageId: $languageId, type: $createdType) {
    count
  }
  rejected: cardsList(userId: $userId, languageId: $languageId, type: $rejectedType) {
    count
  }
  pending: cardsList(userId: $userId, languageId: $languageId, type: $pendingType) {
    count
  }
  pendingEscalation: cardsList(userId: $userId, languageId: $languageId, type: $pendingEscalationType) {
    count
  }
  reviewed: cardsList(userId: $userId, languageId: $languageId, type: $reviewedType) {
    count
  }
  escalated: cardsList(userId: $userId, languageId: $languageId, type: $escalatedType) {
    count
  }
}
    `;
export type CardsCountersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CardsCountersQuery, CardsCountersQueryVariables>, 'query'> & ({ variables: CardsCountersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CardsCountersComponent = (props: CardsCountersComponentProps) => (
      <ApolloReactComponents.Query<CardsCountersQuery, CardsCountersQueryVariables> query={CardsCountersDocument} {...props} />
    );
    

/**
 * __useCardsCountersQuery__
 *
 * To run a query within a React component, call `useCardsCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsCountersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      languageId: // value for 'languageId'
 *      createdType: // value for 'createdType'
 *      rejectedType: // value for 'rejectedType'
 *      pendingType: // value for 'pendingType'
 *      pendingEscalationType: // value for 'pendingEscalationType'
 *      reviewedType: // value for 'reviewedType'
 *      escalatedType: // value for 'escalatedType'
 *   },
 * });
 */
export function useCardsCountersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardsCountersQuery, CardsCountersQueryVariables>) {
        return ApolloReactHooks.useQuery<CardsCountersQuery, CardsCountersQueryVariables>(CardsCountersDocument, baseOptions);
      }
export function useCardsCountersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardsCountersQuery, CardsCountersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardsCountersQuery, CardsCountersQueryVariables>(CardsCountersDocument, baseOptions);
        }
export type CardsCountersQueryHookResult = ReturnType<typeof useCardsCountersQuery>;
export type CardsCountersLazyQueryHookResult = ReturnType<typeof useCardsCountersLazyQuery>;
export type CardsCountersQueryResult = ApolloReactCommon.QueryResult<CardsCountersQuery, CardsCountersQueryVariables>;
export const CardsListDocument = gql`
    query CardsList($userId: Int, $search: String, $languageId: Int!, $limit: Int!, $offset: Int!, $type: String!) {
  cardsList(userId: $userId, search: $search, languageId: $languageId, limit: $limit, offset: $offset, type: $type) {
    count
    cards {
      ...ExtendedCard
    }
  }
}
    ${ExtendedCardFragmentDoc}`;
export type CardsListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CardsListQuery, CardsListQueryVariables>, 'query'> & ({ variables: CardsListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CardsListComponent = (props: CardsListComponentProps) => (
      <ApolloReactComponents.Query<CardsListQuery, CardsListQueryVariables> query={CardsListDocument} {...props} />
    );
    

/**
 * __useCardsListQuery__
 *
 * To run a query within a React component, call `useCardsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsListQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      search: // value for 'search'
 *      languageId: // value for 'languageId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCardsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardsListQuery, CardsListQueryVariables>) {
        return ApolloReactHooks.useQuery<CardsListQuery, CardsListQueryVariables>(CardsListDocument, baseOptions);
      }
export function useCardsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardsListQuery, CardsListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardsListQuery, CardsListQueryVariables>(CardsListDocument, baseOptions);
        }
export type CardsListQueryHookResult = ReturnType<typeof useCardsListQuery>;
export type CardsListLazyQueryHookResult = ReturnType<typeof useCardsListLazyQuery>;
export type CardsListQueryResult = ApolloReactCommon.QueryResult<CardsListQuery, CardsListQueryVariables>;
export const GetExerciseCardByIdDocument = gql`
    query GetExerciseCardById($id: Int!) {
  card(id: $id) {
    id
    course {
      id
      sourceLanguage {
        id
      }
      translationLanguage {
        id
      }
    }
    falseAnswers
    exerciseTranslation
    explanationRules
    counterQuotaExplanation1
    quotaExplanation1
    explanation {
      id
      explanationRules
      course {
        id
      }
      topic {
        id
      }
      explanationExercises {
        id
        postTitle
        explanationRules
        exerciseTranslation
        falseAnswers
        infinitivesOnly
      }
    }
    infinitivesOnly
    topic {
      id
      title
      description
    }
    previouslyCreatedVocabulary {
      wordTranslation {
        sourceWord {
          rank
        }
      }
    }
    postAuthorName
    approvingName
    reviewDescription
    approvedAt
    disapprovedAt
  }
}
    `;
export type GetExerciseCardByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>, 'query'> & ({ variables: GetExerciseCardByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetExerciseCardByIdComponent = (props: GetExerciseCardByIdComponentProps) => (
      <ApolloReactComponents.Query<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables> query={GetExerciseCardByIdDocument} {...props} />
    );
    

/**
 * __useGetExerciseCardByIdQuery__
 *
 * To run a query within a React component, call `useGetExerciseCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExerciseCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExerciseCardByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExerciseCardByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>(GetExerciseCardByIdDocument, baseOptions);
      }
export function useGetExerciseCardByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>(GetExerciseCardByIdDocument, baseOptions);
        }
export type GetExerciseCardByIdQueryHookResult = ReturnType<typeof useGetExerciseCardByIdQuery>;
export type GetExerciseCardByIdLazyQueryHookResult = ReturnType<typeof useGetExerciseCardByIdLazyQuery>;
export type GetExerciseCardByIdQueryResult = ApolloReactCommon.QueryResult<GetExerciseCardByIdQuery, GetExerciseCardByIdQueryVariables>;
export const ExplanationCardDocument = gql`
    query ExplanationCard($id: Int!) {
  card(id: $id) {
    id
    postTitle
    explanationRules
    topic {
      id
      title
      description
    }
    course {
      id
    }
  }
}
    `;
export type ExplanationCardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExplanationCardQuery, ExplanationCardQueryVariables>, 'query'> & ({ variables: ExplanationCardQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExplanationCardComponent = (props: ExplanationCardComponentProps) => (
      <ApolloReactComponents.Query<ExplanationCardQuery, ExplanationCardQueryVariables> query={ExplanationCardDocument} {...props} />
    );
    

/**
 * __useExplanationCardQuery__
 *
 * To run a query within a React component, call `useExplanationCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplanationCardQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplanationCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExplanationCardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExplanationCardQuery, ExplanationCardQueryVariables>) {
        return ApolloReactHooks.useQuery<ExplanationCardQuery, ExplanationCardQueryVariables>(ExplanationCardDocument, baseOptions);
      }
export function useExplanationCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExplanationCardQuery, ExplanationCardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ExplanationCardQuery, ExplanationCardQueryVariables>(ExplanationCardDocument, baseOptions);
        }
export type ExplanationCardQueryHookResult = ReturnType<typeof useExplanationCardQuery>;
export type ExplanationCardLazyQueryHookResult = ReturnType<typeof useExplanationCardLazyQuery>;
export type ExplanationCardQueryResult = ApolloReactCommon.QueryResult<ExplanationCardQuery, ExplanationCardQueryVariables>;
export const GetMnemoCardByIdDocument = gql`
    query GetMnemoCardById($id: Int!) {
  mnemo(id: $id) {
    id
    card {
      wordTranslation {
        audio
        sourceWord {
          lemma
          pos
          posDefinition
          rank
        }
        translationWord {
          lemma
        }
        sourceLanguage {
          id
          name
        }
        translationLanguage {
          id
          name
        }
      }
    }
    feedback
    sentence
    shortSentence
    mnemoKeyword
    approvingName
    approvedAt
    postAuthorName
    disapprovedAt
    disapproveComment
  }
}
    `;
export type GetMnemoCardByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>, 'query'> & ({ variables: GetMnemoCardByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMnemoCardByIdComponent = (props: GetMnemoCardByIdComponentProps) => (
      <ApolloReactComponents.Query<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables> query={GetMnemoCardByIdDocument} {...props} />
    );
    

/**
 * __useGetMnemoCardByIdQuery__
 *
 * To run a query within a React component, call `useGetMnemoCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMnemoCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMnemoCardByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMnemoCardByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>(GetMnemoCardByIdDocument, baseOptions);
      }
export function useGetMnemoCardByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>(GetMnemoCardByIdDocument, baseOptions);
        }
export type GetMnemoCardByIdQueryHookResult = ReturnType<typeof useGetMnemoCardByIdQuery>;
export type GetMnemoCardByIdLazyQueryHookResult = ReturnType<typeof useGetMnemoCardByIdLazyQuery>;
export type GetMnemoCardByIdQueryResult = ApolloReactCommon.QueryResult<GetMnemoCardByIdQuery, GetMnemoCardByIdQueryVariables>;
export const GetRecentTopicDocument = gql`
    query GetRecentTopic($translationLanguage: Int!, $sourceLanguage: Int!, $cardId: Int!, $rank: Int!) {
  recentTopic(translationLanguage: $translationLanguage, sourceLanguage: $sourceLanguage, rank: $rank, cardId: $cardId) {
    topic {
      id
      title
      description
    }
    explanation {
      id
      explanationRules
      course {
        id
      }
      topic {
        id
      }
    }
    cards {
      id
      exampleSentence2
    }
  }
}
    `;
export type GetRecentTopicComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecentTopicQuery, GetRecentTopicQueryVariables>, 'query'> & ({ variables: GetRecentTopicQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRecentTopicComponent = (props: GetRecentTopicComponentProps) => (
      <ApolloReactComponents.Query<GetRecentTopicQuery, GetRecentTopicQueryVariables> query={GetRecentTopicDocument} {...props} />
    );
    

/**
 * __useGetRecentTopicQuery__
 *
 * To run a query within a React component, call `useGetRecentTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentTopicQuery({
 *   variables: {
 *      translationLanguage: // value for 'translationLanguage'
 *      sourceLanguage: // value for 'sourceLanguage'
 *      cardId: // value for 'cardId'
 *      rank: // value for 'rank'
 *   },
 * });
 */
export function useGetRecentTopicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecentTopicQuery, GetRecentTopicQueryVariables>) {
        return ApolloReactHooks.useQuery<GetRecentTopicQuery, GetRecentTopicQueryVariables>(GetRecentTopicDocument, baseOptions);
      }
export function useGetRecentTopicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecentTopicQuery, GetRecentTopicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetRecentTopicQuery, GetRecentTopicQueryVariables>(GetRecentTopicDocument, baseOptions);
        }
export type GetRecentTopicQueryHookResult = ReturnType<typeof useGetRecentTopicQuery>;
export type GetRecentTopicLazyQueryHookResult = ReturnType<typeof useGetRecentTopicLazyQuery>;
export type GetRecentTopicQueryResult = ApolloReactCommon.QueryResult<GetRecentTopicQuery, GetRecentTopicQueryVariables>;
export const RecentExplanationsDocument = gql`
    query RecentExplanations($topic: Int!) {
  recentExplanations(topic: $topic) {
    id
    postTitle
    explanationRules
    course {
      id
    }
    topic {
      id
    }
  }
}
    `;
export type RecentExplanationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentExplanationsQuery, RecentExplanationsQueryVariables>, 'query'> & ({ variables: RecentExplanationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RecentExplanationsComponent = (props: RecentExplanationsComponentProps) => (
      <ApolloReactComponents.Query<RecentExplanationsQuery, RecentExplanationsQueryVariables> query={RecentExplanationsDocument} {...props} />
    );
    

/**
 * __useRecentExplanationsQuery__
 *
 * To run a query within a React component, call `useRecentExplanationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentExplanationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentExplanationsQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useRecentExplanationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentExplanationsQuery, RecentExplanationsQueryVariables>) {
        return ApolloReactHooks.useQuery<RecentExplanationsQuery, RecentExplanationsQueryVariables>(RecentExplanationsDocument, baseOptions);
      }
export function useRecentExplanationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentExplanationsQuery, RecentExplanationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RecentExplanationsQuery, RecentExplanationsQueryVariables>(RecentExplanationsDocument, baseOptions);
        }
export type RecentExplanationsQueryHookResult = ReturnType<typeof useRecentExplanationsQuery>;
export type RecentExplanationsLazyQueryHookResult = ReturnType<typeof useRecentExplanationsLazyQuery>;
export type RecentExplanationsQueryResult = ApolloReactCommon.QueryResult<RecentExplanationsQuery, RecentExplanationsQueryVariables>;
export const ReleaseMnemoCardsDocument = gql`
    query ReleaseMnemoCards($courseId: Int!) {
  unreleasedMnemos(courseId: $courseId) {
    ...ExtendedCard
  }
}
    ${ExtendedCardFragmentDoc}`;
export type ReleaseMnemoCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>, 'query'> & ({ variables: ReleaseMnemoCardsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReleaseMnemoCardsComponent = (props: ReleaseMnemoCardsComponentProps) => (
      <ApolloReactComponents.Query<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables> query={ReleaseMnemoCardsDocument} {...props} />
    );
    

/**
 * __useReleaseMnemoCardsQuery__
 *
 * To run a query within a React component, call `useReleaseMnemoCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReleaseMnemoCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReleaseMnemoCardsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useReleaseMnemoCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>(ReleaseMnemoCardsDocument, baseOptions);
      }
export function useReleaseMnemoCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>(ReleaseMnemoCardsDocument, baseOptions);
        }
export type ReleaseMnemoCardsQueryHookResult = ReturnType<typeof useReleaseMnemoCardsQuery>;
export type ReleaseMnemoCardsLazyQueryHookResult = ReturnType<typeof useReleaseMnemoCardsLazyQuery>;
export type ReleaseMnemoCardsQueryResult = ApolloReactCommon.QueryResult<ReleaseMnemoCardsQuery, ReleaseMnemoCardsQueryVariables>;
export const SearchCardsDocument = gql`
    query SearchCards($word: String, $content: String, $courseId: Int) {
  searchCards(word: $word, content: $content, courseId: $courseId) {
    id
    sourceLemma
    translationId
    translationLemma
    wordRank
    topicTitle
    exerciseRules
    explanationRules
    relatedExplanationId
    exerciseTitle
    explanationTitle
  }
}
    `;
export type SearchCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchCardsQuery, SearchCardsQueryVariables>, 'query'>;

    export const SearchCardsComponent = (props: SearchCardsComponentProps) => (
      <ApolloReactComponents.Query<SearchCardsQuery, SearchCardsQueryVariables> query={SearchCardsDocument} {...props} />
    );
    

/**
 * __useSearchCardsQuery__
 *
 * To run a query within a React component, call `useSearchCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCardsQuery({
 *   variables: {
 *      word: // value for 'word'
 *      content: // value for 'content'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useSearchCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchCardsQuery, SearchCardsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchCardsQuery, SearchCardsQueryVariables>(SearchCardsDocument, baseOptions);
      }
export function useSearchCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchCardsQuery, SearchCardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchCardsQuery, SearchCardsQueryVariables>(SearchCardsDocument, baseOptions);
        }
export type SearchCardsQueryHookResult = ReturnType<typeof useSearchCardsQuery>;
export type SearchCardsLazyQueryHookResult = ReturnType<typeof useSearchCardsLazyQuery>;
export type SearchCardsQueryResult = ApolloReactCommon.QueryResult<SearchCardsQuery, SearchCardsQueryVariables>;
export const TopicExercisesDocument = gql`
    query TopicExercises($topic: Int!) {
  topicExercises(topic: $topic) {
    id
    postTitle
    explanationRules
    falseAnswers
    exerciseTranslation
    infinitivesOnly
    explanation {
      id
      postTitle
      explanationRules
      course {
        id
      }
      topic {
        id
        title
        description
      }
    }
  }
}
    `;
export type TopicExercisesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopicExercisesQuery, TopicExercisesQueryVariables>, 'query'> & ({ variables: TopicExercisesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TopicExercisesComponent = (props: TopicExercisesComponentProps) => (
      <ApolloReactComponents.Query<TopicExercisesQuery, TopicExercisesQueryVariables> query={TopicExercisesDocument} {...props} />
    );
    

/**
 * __useTopicExercisesQuery__
 *
 * To run a query within a React component, call `useTopicExercisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicExercisesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicExercisesQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useTopicExercisesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TopicExercisesQuery, TopicExercisesQueryVariables>) {
        return ApolloReactHooks.useQuery<TopicExercisesQuery, TopicExercisesQueryVariables>(TopicExercisesDocument, baseOptions);
      }
export function useTopicExercisesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicExercisesQuery, TopicExercisesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TopicExercisesQuery, TopicExercisesQueryVariables>(TopicExercisesDocument, baseOptions);
        }
export type TopicExercisesQueryHookResult = ReturnType<typeof useTopicExercisesQuery>;
export type TopicExercisesLazyQueryHookResult = ReturnType<typeof useTopicExercisesLazyQuery>;
export type TopicExercisesQueryResult = ApolloReactCommon.QueryResult<TopicExercisesQuery, TopicExercisesQueryVariables>;
export const TopicExplanationsDocument = gql`
    query TopicExplanations($topic: Int!) {
  topicExplanations(topic: $topic) {
    id
    postTitle
    explanationRules
    topic {
      id
      title
      description
    }
  }
}
    `;
export type TopicExplanationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopicExplanationsQuery, TopicExplanationsQueryVariables>, 'query'> & ({ variables: TopicExplanationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TopicExplanationsComponent = (props: TopicExplanationsComponentProps) => (
      <ApolloReactComponents.Query<TopicExplanationsQuery, TopicExplanationsQueryVariables> query={TopicExplanationsDocument} {...props} />
    );
    

/**
 * __useTopicExplanationsQuery__
 *
 * To run a query within a React component, call `useTopicExplanationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicExplanationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicExplanationsQuery({
 *   variables: {
 *      topic: // value for 'topic'
 *   },
 * });
 */
export function useTopicExplanationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TopicExplanationsQuery, TopicExplanationsQueryVariables>) {
        return ApolloReactHooks.useQuery<TopicExplanationsQuery, TopicExplanationsQueryVariables>(TopicExplanationsDocument, baseOptions);
      }
export function useTopicExplanationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicExplanationsQuery, TopicExplanationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TopicExplanationsQuery, TopicExplanationsQueryVariables>(TopicExplanationsDocument, baseOptions);
        }
export type TopicExplanationsQueryHookResult = ReturnType<typeof useTopicExplanationsQuery>;
export type TopicExplanationsLazyQueryHookResult = ReturnType<typeof useTopicExplanationsLazyQuery>;
export type TopicExplanationsQueryResult = ApolloReactCommon.QueryResult<TopicExplanationsQuery, TopicExplanationsQueryVariables>;
export const GetVocabularyCardByIdDocument = gql`
    query GetVocabularyCardById($id: Int!) {
  card(id: $id) {
    id
    course {
      id
      sourceLanguage {
        id
      }
      translationLanguage {
        id
      }
    }
    wordTranslation {
      id
      audio
      sourceLanguage {
        id
        name
      }
      translationLanguage {
        id
        name
      }
      separateMeanings
      translationWord {
        id
        lemma
      }
      sourceWord {
        id
        lemma
        rank
        pos
        posDefinition
      }
    }
    infinitivesOnly
    infinitivesOnly2
    sentenceAudio
    sentenceAudio2
    exampleSentenceTranslation
    exampleSentenceTranslation2
    exampleSentence
    exampleSentence2
    counterQuotaExplanation1
    counterQuotaExplanation2
    quotaExplanation1
    quotaExplanation2
    info
    infoDisapproveComment
    derivableFromWords
    postAuthorName
    approvingName
    reviewDescription
    editingRequiredAt
    editingRequiredComment
  }
}
    `;
export type GetVocabularyCardByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>, 'query'> & ({ variables: GetVocabularyCardByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVocabularyCardByIdComponent = (props: GetVocabularyCardByIdComponentProps) => (
      <ApolloReactComponents.Query<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables> query={GetVocabularyCardByIdDocument} {...props} />
    );
    

/**
 * __useGetVocabularyCardByIdQuery__
 *
 * To run a query within a React component, call `useGetVocabularyCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVocabularyCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVocabularyCardByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVocabularyCardByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>(GetVocabularyCardByIdDocument, baseOptions);
      }
export function useGetVocabularyCardByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>(GetVocabularyCardByIdDocument, baseOptions);
        }
export type GetVocabularyCardByIdQueryHookResult = ReturnType<typeof useGetVocabularyCardByIdQuery>;
export type GetVocabularyCardByIdLazyQueryHookResult = ReturnType<typeof useGetVocabularyCardByIdLazyQuery>;
export type GetVocabularyCardByIdQueryResult = ApolloReactCommon.QueryResult<GetVocabularyCardByIdQuery, GetVocabularyCardByIdQueryVariables>;
export const GetAllowedCoursesDocument = gql`
    query GetAllowedCourses($userId: Int) {
  allowedCourses(userId: $userId) {
    id
    sourceLanguage {
      id
      name
      code
    }
    translationLanguage {
      id
      name
      code
    }
  }
}
    `;
export type GetAllowedCoursesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>, 'query'>;

    export const GetAllowedCoursesComponent = (props: GetAllowedCoursesComponentProps) => (
      <ApolloReactComponents.Query<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables> query={GetAllowedCoursesDocument} {...props} />
    );
    

/**
 * __useGetAllowedCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllowedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedCoursesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAllowedCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>(GetAllowedCoursesDocument, baseOptions);
      }
export function useGetAllowedCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>(GetAllowedCoursesDocument, baseOptions);
        }
export type GetAllowedCoursesQueryHookResult = ReturnType<typeof useGetAllowedCoursesQuery>;
export type GetAllowedCoursesLazyQueryHookResult = ReturnType<typeof useGetAllowedCoursesLazyQuery>;
export type GetAllowedCoursesQueryResult = ApolloReactCommon.QueryResult<GetAllowedCoursesQuery, GetAllowedCoursesQueryVariables>;
export const AllCoursesDocument = gql`
    query AllCourses {
  courses {
    ...CourseDetails
  }
}
    ${CourseDetailsFragmentDoc}`;
export type AllCoursesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllCoursesQuery, AllCoursesQueryVariables>, 'query'>;

    export const AllCoursesComponent = (props: AllCoursesComponentProps) => (
      <ApolloReactComponents.Query<AllCoursesQuery, AllCoursesQueryVariables> query={AllCoursesDocument} {...props} />
    );
    

/**
 * __useAllCoursesQuery__
 *
 * To run a query within a React component, call `useAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, baseOptions);
      }
export function useAllCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, baseOptions);
        }
export type AllCoursesQueryHookResult = ReturnType<typeof useAllCoursesQuery>;
export type AllCoursesLazyQueryHookResult = ReturnType<typeof useAllCoursesLazyQuery>;
export type AllCoursesQueryResult = ApolloReactCommon.QueryResult<AllCoursesQuery, AllCoursesQueryVariables>;
export const LanguageCoursesDocument = gql`
    query LanguageCourses($languageId: Int!) {
  coursesByLanguage(languageId: $languageId) {
    id
    title
    sourceLanguage {
      id
      name
    }
    translationLanguage {
      id
      name
    }
    stages {
      id
      level
      countExplanationCards
      topics {
        id
        title
      }
    }
  }
}
    `;
export type LanguageCoursesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LanguageCoursesQuery, LanguageCoursesQueryVariables>, 'query'> & ({ variables: LanguageCoursesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LanguageCoursesComponent = (props: LanguageCoursesComponentProps) => (
      <ApolloReactComponents.Query<LanguageCoursesQuery, LanguageCoursesQueryVariables> query={LanguageCoursesDocument} {...props} />
    );
    

/**
 * __useLanguageCoursesQuery__
 *
 * To run a query within a React component, call `useLanguageCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageCoursesQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useLanguageCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LanguageCoursesQuery, LanguageCoursesQueryVariables>) {
        return ApolloReactHooks.useQuery<LanguageCoursesQuery, LanguageCoursesQueryVariables>(LanguageCoursesDocument, baseOptions);
      }
export function useLanguageCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LanguageCoursesQuery, LanguageCoursesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LanguageCoursesQuery, LanguageCoursesQueryVariables>(LanguageCoursesDocument, baseOptions);
        }
export type LanguageCoursesQueryHookResult = ReturnType<typeof useLanguageCoursesQuery>;
export type LanguageCoursesLazyQueryHookResult = ReturnType<typeof useLanguageCoursesLazyQuery>;
export type LanguageCoursesQueryResult = ApolloReactCommon.QueryResult<LanguageCoursesQuery, LanguageCoursesQueryVariables>;
export const GetNextCardUrlDocument = gql`
    query GetNextCardUrl($courseId: Int!, $role: String!, $backToStream: Int) {
  nextCardUrl(courseId: $courseId, role: $role, backIntoCreationStream: $backToStream)
}
    `;
export type GetNextCardUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>, 'query'> & ({ variables: GetNextCardUrlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNextCardUrlComponent = (props: GetNextCardUrlComponentProps) => (
      <ApolloReactComponents.Query<GetNextCardUrlQuery, GetNextCardUrlQueryVariables> query={GetNextCardUrlDocument} {...props} />
    );
    

/**
 * __useGetNextCardUrlQuery__
 *
 * To run a query within a React component, call `useGetNextCardUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextCardUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextCardUrlQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      role: // value for 'role'
 *      backToStream: // value for 'backToStream'
 *   },
 * });
 */
export function useGetNextCardUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>(GetNextCardUrlDocument, baseOptions);
      }
export function useGetNextCardUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>(GetNextCardUrlDocument, baseOptions);
        }
export type GetNextCardUrlQueryHookResult = ReturnType<typeof useGetNextCardUrlQuery>;
export type GetNextCardUrlLazyQueryHookResult = ReturnType<typeof useGetNextCardUrlLazyQuery>;
export type GetNextCardUrlQueryResult = ApolloReactCommon.QueryResult<GetNextCardUrlQuery, GetNextCardUrlQueryVariables>;
export const HelloDocument = gql`
    query Hello($name: String!) {
  hello(name: $name)
}
    `;
export type HelloComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HelloQuery, HelloQueryVariables>, 'query'> & ({ variables: HelloQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HelloComponent = (props: HelloComponentProps) => (
      <ApolloReactComponents.Query<HelloQuery, HelloQueryVariables> query={HelloDocument} {...props} />
    );
    

/**
 * __useHelloQuery__
 *
 * To run a query within a React component, call `useHelloQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelloQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelloQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHelloQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HelloQuery, HelloQueryVariables>) {
        return ApolloReactHooks.useQuery<HelloQuery, HelloQueryVariables>(HelloDocument, baseOptions);
      }
export function useHelloLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HelloQuery, HelloQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HelloQuery, HelloQueryVariables>(HelloDocument, baseOptions);
        }
export type HelloQueryHookResult = ReturnType<typeof useHelloQuery>;
export type HelloLazyQueryHookResult = ReturnType<typeof useHelloLazyQuery>;
export type HelloQueryResult = ApolloReactCommon.QueryResult<HelloQuery, HelloQueryVariables>;
export const LanguagesDocument = gql`
    query Languages {
  languages {
    id
    name
    code
  }
}
    `;
export type LanguagesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LanguagesQuery, LanguagesQueryVariables>, 'query'>;

    export const LanguagesComponent = (props: LanguagesComponentProps) => (
      <ApolloReactComponents.Query<LanguagesQuery, LanguagesQueryVariables> query={LanguagesDocument} {...props} />
    );
    

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        return ApolloReactHooks.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, baseOptions);
      }
export function useLanguagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, baseOptions);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesQueryResult = ApolloReactCommon.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const LegDocument = gql`
    query Leg($id: Int!) {
  leg(id: $id) {
    id
    postTitle
    position
    popupPicture
    popupPictureId
    image
    imageId
    imagePortrait
    imagePortraitId
  }
}
    `;
export type LegComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LegQuery, LegQueryVariables>, 'query'> & ({ variables: LegQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LegComponent = (props: LegComponentProps) => (
      <ApolloReactComponents.Query<LegQuery, LegQueryVariables> query={LegDocument} {...props} />
    );
    

/**
 * __useLegQuery__
 *
 * To run a query within a React component, call `useLegQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LegQuery, LegQueryVariables>) {
        return ApolloReactHooks.useQuery<LegQuery, LegQueryVariables>(LegDocument, baseOptions);
      }
export function useLegLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegQuery, LegQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LegQuery, LegQueryVariables>(LegDocument, baseOptions);
        }
export type LegQueryHookResult = ReturnType<typeof useLegQuery>;
export type LegLazyQueryHookResult = ReturnType<typeof useLegLazyQuery>;
export type LegQueryResult = ApolloReactCommon.QueryResult<LegQuery, LegQueryVariables>;
export const LegsDocument = gql`
    query Legs($stage: Int!) {
  stageLegs(stage: $stage) {
    id
    postTitle
    position
    popupPicture
    image
    imagePortrait
  }
}
    `;
export type LegsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LegsQuery, LegsQueryVariables>, 'query'> & ({ variables: LegsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LegsComponent = (props: LegsComponentProps) => (
      <ApolloReactComponents.Query<LegsQuery, LegsQueryVariables> query={LegsDocument} {...props} />
    );
    

/**
 * __useLegsQuery__
 *
 * To run a query within a React component, call `useLegsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegsQuery({
 *   variables: {
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useLegsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LegsQuery, LegsQueryVariables>) {
        return ApolloReactHooks.useQuery<LegsQuery, LegsQueryVariables>(LegsDocument, baseOptions);
      }
export function useLegsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegsQuery, LegsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LegsQuery, LegsQueryVariables>(LegsDocument, baseOptions);
        }
export type LegsQueryHookResult = ReturnType<typeof useLegsQuery>;
export type LegsLazyQueryHookResult = ReturnType<typeof useLegsLazyQuery>;
export type LegsQueryResult = ApolloReactCommon.QueryResult<LegsQuery, LegsQueryVariables>;
export const OptimizedAudioAvailableDocument = gql`
    query OptimizedAudioAvailable($id: Int!, $fileUrl: String!, $noTimeout: Boolean) {
  optimizedAudioAvailable(id: $id, fileUrl: $fileUrl, noTimeout: $noTimeout) {
    id
    url
    status
    message
  }
}
    `;
export type OptimizedAudioAvailableComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>, 'query'> & ({ variables: OptimizedAudioAvailableQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OptimizedAudioAvailableComponent = (props: OptimizedAudioAvailableComponentProps) => (
      <ApolloReactComponents.Query<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables> query={OptimizedAudioAvailableDocument} {...props} />
    );
    

/**
 * __useOptimizedAudioAvailableQuery__
 *
 * To run a query within a React component, call `useOptimizedAudioAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizedAudioAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizedAudioAvailableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fileUrl: // value for 'fileUrl'
 *      noTimeout: // value for 'noTimeout'
 *   },
 * });
 */
export function useOptimizedAudioAvailableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>) {
        return ApolloReactHooks.useQuery<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>(OptimizedAudioAvailableDocument, baseOptions);
      }
export function useOptimizedAudioAvailableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>(OptimizedAudioAvailableDocument, baseOptions);
        }
export type OptimizedAudioAvailableQueryHookResult = ReturnType<typeof useOptimizedAudioAvailableQuery>;
export type OptimizedAudioAvailableLazyQueryHookResult = ReturnType<typeof useOptimizedAudioAvailableLazyQuery>;
export type OptimizedAudioAvailableQueryResult = ApolloReactCommon.QueryResult<OptimizedAudioAvailableQuery, OptimizedAudioAvailableQueryVariables>;
export const GetQuotaCheckDocument = gql`
    query GetQuotaCheck($excludedWords: [String!]!, $values: [String!]!, $sourceLanguage: Int!, $translationLanguage: Int!) {
  quotaCheck(excludedWords: $excludedWords, values: $values, sourceLanguage: $sourceLanguage, translationLanguage: $translationLanguage) {
    success
    content
    valid
    quotaData
  }
}
    `;
export type GetQuotaCheckComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>, 'query'> & ({ variables: GetQuotaCheckQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetQuotaCheckComponent = (props: GetQuotaCheckComponentProps) => (
      <ApolloReactComponents.Query<GetQuotaCheckQuery, GetQuotaCheckQueryVariables> query={GetQuotaCheckDocument} {...props} />
    );
    

/**
 * __useGetQuotaCheckQuery__
 *
 * To run a query within a React component, call `useGetQuotaCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotaCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotaCheckQuery({
 *   variables: {
 *      excludedWords: // value for 'excludedWords'
 *      values: // value for 'values'
 *      sourceLanguage: // value for 'sourceLanguage'
 *      translationLanguage: // value for 'translationLanguage'
 *   },
 * });
 */
export function useGetQuotaCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>) {
        return ApolloReactHooks.useQuery<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>(GetQuotaCheckDocument, baseOptions);
      }
export function useGetQuotaCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>(GetQuotaCheckDocument, baseOptions);
        }
export type GetQuotaCheckQueryHookResult = ReturnType<typeof useGetQuotaCheckQuery>;
export type GetQuotaCheckLazyQueryHookResult = ReturnType<typeof useGetQuotaCheckLazyQuery>;
export type GetQuotaCheckQueryResult = ApolloReactCommon.QueryResult<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>;
export const SearchAlreadyCreatedCardsDocument = gql`
    query SearchAlreadyCreatedCards($sourceLanguage: Int!, $translationLanguage: Int!, $query: String!) {
  searchAlreadyCreatedCards(query: $query, sourceLanguage: $sourceLanguage, translationLanguage: $translationLanguage) {
    id
    text
  }
}
    `;
export type SearchAlreadyCreatedCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>, 'query'> & ({ variables: SearchAlreadyCreatedCardsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchAlreadyCreatedCardsComponent = (props: SearchAlreadyCreatedCardsComponentProps) => (
      <ApolloReactComponents.Query<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables> query={SearchAlreadyCreatedCardsDocument} {...props} />
    );
    

/**
 * __useSearchAlreadyCreatedCardsQuery__
 *
 * To run a query within a React component, call `useSearchAlreadyCreatedCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAlreadyCreatedCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAlreadyCreatedCardsQuery({
 *   variables: {
 *      sourceLanguage: // value for 'sourceLanguage'
 *      translationLanguage: // value for 'translationLanguage'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchAlreadyCreatedCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>(SearchAlreadyCreatedCardsDocument, baseOptions);
      }
export function useSearchAlreadyCreatedCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>(SearchAlreadyCreatedCardsDocument, baseOptions);
        }
export type SearchAlreadyCreatedCardsQueryHookResult = ReturnType<typeof useSearchAlreadyCreatedCardsQuery>;
export type SearchAlreadyCreatedCardsLazyQueryHookResult = ReturnType<typeof useSearchAlreadyCreatedCardsLazyQuery>;
export type SearchAlreadyCreatedCardsQueryResult = ApolloReactCommon.QueryResult<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>;
export const SearchTranslationsDocument = gql`
    query SearchTranslations($sourceLanguage: Int!, $translationLanguage: Int!, $query: String!) {
  searchTranslations(query: $query, sourceLanguage: $sourceLanguage, translationLanguage: $translationLanguage) {
    id
    text
  }
}
    `;
export type SearchTranslationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchTranslationsQuery, SearchTranslationsQueryVariables>, 'query'> & ({ variables: SearchTranslationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchTranslationsComponent = (props: SearchTranslationsComponentProps) => (
      <ApolloReactComponents.Query<SearchTranslationsQuery, SearchTranslationsQueryVariables> query={SearchTranslationsDocument} {...props} />
    );
    

/**
 * __useSearchTranslationsQuery__
 *
 * To run a query within a React component, call `useSearchTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTranslationsQuery({
 *   variables: {
 *      sourceLanguage: // value for 'sourceLanguage'
 *      translationLanguage: // value for 'translationLanguage'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTranslationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTranslationsQuery, SearchTranslationsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchTranslationsQuery, SearchTranslationsQueryVariables>(SearchTranslationsDocument, baseOptions);
      }
export function useSearchTranslationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTranslationsQuery, SearchTranslationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchTranslationsQuery, SearchTranslationsQueryVariables>(SearchTranslationsDocument, baseOptions);
        }
export type SearchTranslationsQueryHookResult = ReturnType<typeof useSearchTranslationsQuery>;
export type SearchTranslationsLazyQueryHookResult = ReturnType<typeof useSearchTranslationsLazyQuery>;
export type SearchTranslationsQueryResult = ApolloReactCommon.QueryResult<SearchTranslationsQuery, SearchTranslationsQueryVariables>;
export const GetStageForCourseDocument = gql`
    query GetStageForCourse($courseId: Int!) {
  stageForCourse(courseId: $courseId) {
    id
  }
}
    `;
export type GetStageForCourseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetStageForCourseQuery, GetStageForCourseQueryVariables>, 'query'> & ({ variables: GetStageForCourseQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetStageForCourseComponent = (props: GetStageForCourseComponentProps) => (
      <ApolloReactComponents.Query<GetStageForCourseQuery, GetStageForCourseQueryVariables> query={GetStageForCourseDocument} {...props} />
    );
    

/**
 * __useGetStageForCourseQuery__
 *
 * To run a query within a React component, call `useGetStageForCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageForCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStageForCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetStageForCourseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStageForCourseQuery, GetStageForCourseQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStageForCourseQuery, GetStageForCourseQueryVariables>(GetStageForCourseDocument, baseOptions);
      }
export function useGetStageForCourseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStageForCourseQuery, GetStageForCourseQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStageForCourseQuery, GetStageForCourseQueryVariables>(GetStageForCourseDocument, baseOptions);
        }
export type GetStageForCourseQueryHookResult = ReturnType<typeof useGetStageForCourseQuery>;
export type GetStageForCourseLazyQueryHookResult = ReturnType<typeof useGetStageForCourseLazyQuery>;
export type GetStageForCourseQueryResult = ApolloReactCommon.QueryResult<GetStageForCourseQuery, GetStageForCourseQueryVariables>;
export const CardsPerDayDocument = gql`
    query CardsPerDay($role: String!) {
  cardsPerDay(role: $role)
}
    `;
export type CardsPerDayComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CardsPerDayQuery, CardsPerDayQueryVariables>, 'query'> & ({ variables: CardsPerDayQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CardsPerDayComponent = (props: CardsPerDayComponentProps) => (
      <ApolloReactComponents.Query<CardsPerDayQuery, CardsPerDayQueryVariables> query={CardsPerDayDocument} {...props} />
    );
    

/**
 * __useCardsPerDayQuery__
 *
 * To run a query within a React component, call `useCardsPerDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardsPerDayQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardsPerDayQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCardsPerDayQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CardsPerDayQuery, CardsPerDayQueryVariables>) {
        return ApolloReactHooks.useQuery<CardsPerDayQuery, CardsPerDayQueryVariables>(CardsPerDayDocument, baseOptions);
      }
export function useCardsPerDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CardsPerDayQuery, CardsPerDayQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CardsPerDayQuery, CardsPerDayQueryVariables>(CardsPerDayDocument, baseOptions);
        }
export type CardsPerDayQueryHookResult = ReturnType<typeof useCardsPerDayQuery>;
export type CardsPerDayLazyQueryHookResult = ReturnType<typeof useCardsPerDayLazyQuery>;
export type CardsPerDayQueryResult = ApolloReactCommon.QueryResult<CardsPerDayQuery, CardsPerDayQueryVariables>;
export const LpExtendedStatsDocument = gql`
    query LpExtendedStats($my: Boolean, $userId: Int, $periods: [PeriodItemInput!]!) {
  stats(my: $my, role: "LP", periods: $periods, userId: $userId) {
    period
    details {
      ...LpExtendedStatsFragment
    }
  }
}
    ${LpExtendedStatsFragmentFragmentDoc}`;
export type LpExtendedStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>, 'query'> & ({ variables: LpExtendedStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LpExtendedStatsComponent = (props: LpExtendedStatsComponentProps) => (
      <ApolloReactComponents.Query<LpExtendedStatsQuery, LpExtendedStatsQueryVariables> query={LpExtendedStatsDocument} {...props} />
    );
    

/**
 * __useLpExtendedStatsQuery__
 *
 * To run a query within a React component, call `useLpExtendedStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpExtendedStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpExtendedStatsQuery({
 *   variables: {
 *      my: // value for 'my'
 *      userId: // value for 'userId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useLpExtendedStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>(LpExtendedStatsDocument, baseOptions);
      }
export function useLpExtendedStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>(LpExtendedStatsDocument, baseOptions);
        }
export type LpExtendedStatsQueryHookResult = ReturnType<typeof useLpExtendedStatsQuery>;
export type LpExtendedStatsLazyQueryHookResult = ReturnType<typeof useLpExtendedStatsLazyQuery>;
export type LpExtendedStatsQueryResult = ApolloReactCommon.QueryResult<LpExtendedStatsQuery, LpExtendedStatsQueryVariables>;
export const LpStatsDocument = gql`
    query LpStats($my: Boolean, $userId: Int, $periods: [PeriodItemInput!]!) {
  stats(my: $my, role: "LP", periods: $periods, userId: $userId) {
    period
    details {
      ...LpStatsFragment
    }
  }
}
    ${LpStatsFragmentFragmentDoc}`;
export type LpStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<LpStatsQuery, LpStatsQueryVariables>, 'query'> & ({ variables: LpStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const LpStatsComponent = (props: LpStatsComponentProps) => (
      <ApolloReactComponents.Query<LpStatsQuery, LpStatsQueryVariables> query={LpStatsDocument} {...props} />
    );
    

/**
 * __useLpStatsQuery__
 *
 * To run a query within a React component, call `useLpStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLpStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLpStatsQuery({
 *   variables: {
 *      my: // value for 'my'
 *      userId: // value for 'userId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useLpStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LpStatsQuery, LpStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<LpStatsQuery, LpStatsQueryVariables>(LpStatsDocument, baseOptions);
      }
export function useLpStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LpStatsQuery, LpStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LpStatsQuery, LpStatsQueryVariables>(LpStatsDocument, baseOptions);
        }
export type LpStatsQueryHookResult = ReturnType<typeof useLpStatsQuery>;
export type LpStatsLazyQueryHookResult = ReturnType<typeof useLpStatsLazyQuery>;
export type LpStatsQueryResult = ApolloReactCommon.QueryResult<LpStatsQuery, LpStatsQueryVariables>;
export const McStatsDocument = gql`
    query McStats($my: Boolean, $userId: Int, $periods: [PeriodItemInput!]!) {
  stats(my: $my, role: "MC", periods: $periods, userId: $userId) {
    period
    details {
      ...McStatsFragment
    }
  }
}
    ${McStatsFragmentFragmentDoc}`;
export type McStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<McStatsQuery, McStatsQueryVariables>, 'query'> & ({ variables: McStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const McStatsComponent = (props: McStatsComponentProps) => (
      <ApolloReactComponents.Query<McStatsQuery, McStatsQueryVariables> query={McStatsDocument} {...props} />
    );
    

/**
 * __useMcStatsQuery__
 *
 * To run a query within a React component, call `useMcStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcStatsQuery({
 *   variables: {
 *      my: // value for 'my'
 *      userId: // value for 'userId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useMcStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<McStatsQuery, McStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<McStatsQuery, McStatsQueryVariables>(McStatsDocument, baseOptions);
      }
export function useMcStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<McStatsQuery, McStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<McStatsQuery, McStatsQueryVariables>(McStatsDocument, baseOptions);
        }
export type McStatsQueryHookResult = ReturnType<typeof useMcStatsQuery>;
export type McStatsLazyQueryHookResult = ReturnType<typeof useMcStatsLazyQuery>;
export type McStatsQueryResult = ApolloReactCommon.QueryResult<McStatsQuery, McStatsQueryVariables>;
export const MeStatsDocument = gql`
    query MeStats($my: Boolean, $userId: Int, $periods: [PeriodItemInput!]!) {
  stats(my: $my, role: "ME", periods: $periods, userId: $userId) {
    period
    details {
      ...MeStatsFragment
    }
  }
}
    ${MeStatsFragmentFragmentDoc}`;
export type MeStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MeStatsQuery, MeStatsQueryVariables>, 'query'> & ({ variables: MeStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MeStatsComponent = (props: MeStatsComponentProps) => (
      <ApolloReactComponents.Query<MeStatsQuery, MeStatsQueryVariables> query={MeStatsDocument} {...props} />
    );
    

/**
 * __useMeStatsQuery__
 *
 * To run a query within a React component, call `useMeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeStatsQuery({
 *   variables: {
 *      my: // value for 'my'
 *      userId: // value for 'userId'
 *      periods: // value for 'periods'
 *   },
 * });
 */
export function useMeStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeStatsQuery, MeStatsQueryVariables>) {
        return ApolloReactHooks.useQuery<MeStatsQuery, MeStatsQueryVariables>(MeStatsDocument, baseOptions);
      }
export function useMeStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeStatsQuery, MeStatsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MeStatsQuery, MeStatsQueryVariables>(MeStatsDocument, baseOptions);
        }
export type MeStatsQueryHookResult = ReturnType<typeof useMeStatsQuery>;
export type MeStatsLazyQueryHookResult = ReturnType<typeof useMeStatsLazyQuery>;
export type MeStatsQueryResult = ApolloReactCommon.QueryResult<MeStatsQuery, MeStatsQueryVariables>;
export const RolesListDocument = gql`
    query RolesList($role: String!, $courseId: Int) {
  rolesList(role: $role, courseId: $courseId) {
    id
    name
    registered
    allowedCourses
    stats {
      period
      details {
        ...LpExtendedStatsFragment
        ...McStatsFragment
        ...MeStatsFragment
      }
    }
  }
}
    ${LpExtendedStatsFragmentFragmentDoc}
${McStatsFragmentFragmentDoc}
${MeStatsFragmentFragmentDoc}`;
export type RolesListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RolesListQuery, RolesListQueryVariables>, 'query'> & ({ variables: RolesListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RolesListComponent = (props: RolesListComponentProps) => (
      <ApolloReactComponents.Query<RolesListQuery, RolesListQueryVariables> query={RolesListDocument} {...props} />
    );
    

/**
 * __useRolesListQuery__
 *
 * To run a query within a React component, call `useRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesListQuery({
 *   variables: {
 *      role: // value for 'role'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRolesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
        return ApolloReactHooks.useQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, baseOptions);
      }
export function useRolesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RolesListQuery, RolesListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RolesListQuery, RolesListQueryVariables>(RolesListDocument, baseOptions);
        }
export type RolesListQueryHookResult = ReturnType<typeof useRolesListQuery>;
export type RolesListLazyQueryHookResult = ReturnType<typeof useRolesListLazyQuery>;
export type RolesListQueryResult = ApolloReactCommon.QueryResult<RolesListQuery, RolesListQueryVariables>;
export const SearchTopicsDocument = gql`
    query SearchTopics($query: String!) {
  searchTopics(query: $query) {
    id
    title
  }
}
    `;
export type SearchTopicsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchTopicsQuery, SearchTopicsQueryVariables>, 'query'> & ({ variables: SearchTopicsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchTopicsComponent = (props: SearchTopicsComponentProps) => (
      <ApolloReactComponents.Query<SearchTopicsQuery, SearchTopicsQueryVariables> query={SearchTopicsDocument} {...props} />
    );
    

/**
 * __useSearchTopicsQuery__
 *
 * To run a query within a React component, call `useSearchTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTopicsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTopicsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchTopicsQuery, SearchTopicsQueryVariables>(SearchTopicsDocument, baseOptions);
      }
export function useSearchTopicsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchTopicsQuery, SearchTopicsQueryVariables>(SearchTopicsDocument, baseOptions);
        }
export type SearchTopicsQueryHookResult = ReturnType<typeof useSearchTopicsQuery>;
export type SearchTopicsLazyQueryHookResult = ReturnType<typeof useSearchTopicsLazyQuery>;
export type SearchTopicsQueryResult = ApolloReactCommon.QueryResult<SearchTopicsQuery, SearchTopicsQueryVariables>;
export const TopicDocument = gql`
    query Topic($id: Int!) {
  topic(id: $id) {
    id
    title
    description
    relatedTopics
    stage {
      id
      level
      course {
        id
        sourceLanguage {
          id
          name
        }
        translationLanguage {
          id
          name
        }
      }
    }
  }
}
    `;
export type TopicComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopicQuery, TopicQueryVariables>, 'query'> & ({ variables: TopicQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TopicComponent = (props: TopicComponentProps) => (
      <ApolloReactComponents.Query<TopicQuery, TopicQueryVariables> query={TopicDocument} {...props} />
    );
    

/**
 * __useTopicQuery__
 *
 * To run a query within a React component, call `useTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TopicQuery, TopicQueryVariables>) {
        return ApolloReactHooks.useQuery<TopicQuery, TopicQueryVariables>(TopicDocument, baseOptions);
      }
export function useTopicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicQuery, TopicQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TopicQuery, TopicQueryVariables>(TopicDocument, baseOptions);
        }
export type TopicQueryHookResult = ReturnType<typeof useTopicQuery>;
export type TopicLazyQueryHookResult = ReturnType<typeof useTopicLazyQuery>;
export type TopicQueryResult = ApolloReactCommon.QueryResult<TopicQuery, TopicQueryVariables>;
export const TopicsByIdsDocument = gql`
    query TopicsByIds($ids: [Int!]!) {
  topicsByIds(ids: $ids) {
    id
    title
  }
}
    `;
export type TopicsByIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TopicsByIdsQuery, TopicsByIdsQueryVariables>, 'query'> & ({ variables: TopicsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TopicsByIdsComponent = (props: TopicsByIdsComponentProps) => (
      <ApolloReactComponents.Query<TopicsByIdsQuery, TopicsByIdsQueryVariables> query={TopicsByIdsDocument} {...props} />
    );
    

/**
 * __useTopicsByIdsQuery__
 *
 * To run a query within a React component, call `useTopicsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTopicsByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TopicsByIdsQuery, TopicsByIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<TopicsByIdsQuery, TopicsByIdsQueryVariables>(TopicsByIdsDocument, baseOptions);
      }
export function useTopicsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicsByIdsQuery, TopicsByIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TopicsByIdsQuery, TopicsByIdsQueryVariables>(TopicsByIdsDocument, baseOptions);
        }
export type TopicsByIdsQueryHookResult = ReturnType<typeof useTopicsByIdsQuery>;
export type TopicsByIdsLazyQueryHookResult = ReturnType<typeof useTopicsByIdsLazyQuery>;
export type TopicsByIdsQueryResult = ApolloReactCommon.QueryResult<TopicsByIdsQuery, TopicsByIdsQueryVariables>;
export const GetTranslationForVocabularyDocument = gql`
    query GetTranslationForVocabulary($id: Int!) {
  wordTranslation(id: $id) {
    id
    audio
    sourceLanguage {
      id
      name
    }
    translationLanguage {
      id
      name
    }
    translationWord {
      id
      lemma
    }
    sourceWord {
      id
      lemma
      rank
      pos
      posDefinition
      predefinedTranslation {
        id
      }
      predefinedComment
    }
  }
}
    `;
export type GetTranslationForVocabularyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>, 'query'> & ({ variables: GetTranslationForVocabularyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTranslationForVocabularyComponent = (props: GetTranslationForVocabularyComponentProps) => (
      <ApolloReactComponents.Query<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables> query={GetTranslationForVocabularyDocument} {...props} />
    );
    

/**
 * __useGetTranslationForVocabularyQuery__
 *
 * To run a query within a React component, call `useGetTranslationForVocabularyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationForVocabularyQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationForVocabularyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTranslationForVocabularyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>(GetTranslationForVocabularyDocument, baseOptions);
      }
export function useGetTranslationForVocabularyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>(GetTranslationForVocabularyDocument, baseOptions);
        }
export type GetTranslationForVocabularyQueryHookResult = ReturnType<typeof useGetTranslationForVocabularyQuery>;
export type GetTranslationForVocabularyLazyQueryHookResult = ReturnType<typeof useGetTranslationForVocabularyLazyQuery>;
export type GetTranslationForVocabularyQueryResult = ApolloReactCommon.QueryResult<GetTranslationForVocabularyQuery, GetTranslationForVocabularyQueryVariables>;
export const AddSubscriptionDocument = gql`
    mutation AddSubscription($userId: Int!, $courseId: Int, $all: Boolean, $removeAll: Boolean) {
  addSubscription(userId: $userId, courseId: $courseId, all: $all, removeAll: $removeAll)
}
    `;
export type AddSubscriptionMutationFn = ApolloReactCommon.MutationFunction<AddSubscriptionMutation, AddSubscriptionMutationVariables>;
export type AddSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddSubscriptionMutation, AddSubscriptionMutationVariables>, 'mutation'>;

    export const AddSubscriptionComponent = (props: AddSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<AddSubscriptionMutation, AddSubscriptionMutationVariables> mutation={AddSubscriptionDocument} {...props} />
    );
    

/**
 * __useAddSubscriptionMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionMutation, { data, loading, error }] = useAddSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      courseId: // value for 'courseId'
 *      all: // value for 'all'
 *      removeAll: // value for 'removeAll'
 *   },
 * });
 */
export function useAddSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddSubscriptionMutation, AddSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<AddSubscriptionMutation, AddSubscriptionMutationVariables>(AddSubscriptionDocument, baseOptions);
      }
export type AddSubscriptionMutationHookResult = ReturnType<typeof useAddSubscriptionMutation>;
export type AddSubscriptionMutationResult = ApolloReactCommon.MutationResult<AddSubscriptionMutation>;
export type AddSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<AddSubscriptionMutation, AddSubscriptionMutationVariables>;
export const AllUsersDocument = gql`
    query AllUsers($roles: [String!]) {
  allUsers(roles: $roles) {
    id
    email
    firstName
    lastName
  }
}
    `;
export type AllUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllUsersQuery, AllUsersQueryVariables>, 'query'>;

    export const AllUsersComponent = (props: AllUsersComponentProps) => (
      <ApolloReactComponents.Query<AllUsersQuery, AllUsersQueryVariables> query={AllUsersDocument} {...props} />
    );
    

/**
 * __useAllUsersQuery__
 *
 * To run a query within a React component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useAllUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
        return ApolloReactHooks.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, baseOptions);
      }
export function useAllUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllUsersQuery, AllUsersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, baseOptions);
        }
export type AllUsersQueryHookResult = ReturnType<typeof useAllUsersQuery>;
export type AllUsersLazyQueryHookResult = ReturnType<typeof useAllUsersLazyQuery>;
export type AllUsersQueryResult = ApolloReactCommon.QueryResult<AllUsersQuery, AllUsersQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type MeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MeQuery, MeQueryVariables>, 'query'>;

    export const MeComponent = (props: MeComponentProps) => (
      <ApolloReactComponents.Query<MeQuery, MeQueryVariables> query={MeDocument} {...props} />
    );
    

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = ApolloReactCommon.QueryResult<MeQuery, MeQueryVariables>;
export const SearchUserByEmailDocument = gql`
    query SearchUserByEmail($email: String!) {
  user: searchUserByEmail(email: $email) {
    id
    email
    emailConfirmed
    allCoursesEnabled
    coursesEnabled
    firstName
    lastName
    registered
    courses {
      id
      name
      nextVocabulary
      finished
      isAvailable
    }
  }
}
    `;
export type SearchUserByEmailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>, 'query'> & ({ variables: SearchUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchUserByEmailComponent = (props: SearchUserByEmailComponentProps) => (
      <ApolloReactComponents.Query<SearchUserByEmailQuery, SearchUserByEmailQueryVariables> query={SearchUserByEmailDocument} {...props} />
    );
    

/**
 * __useSearchUserByEmailQuery__
 *
 * To run a query within a React component, call `useSearchUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSearchUserByEmailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>) {
        return ApolloReactHooks.useQuery<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>(SearchUserByEmailDocument, baseOptions);
      }
export function useSearchUserByEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>(SearchUserByEmailDocument, baseOptions);
        }
export type SearchUserByEmailQueryHookResult = ReturnType<typeof useSearchUserByEmailQuery>;
export type SearchUserByEmailLazyQueryHookResult = ReturnType<typeof useSearchUserByEmailLazyQuery>;
export type SearchUserByEmailQueryResult = ApolloReactCommon.QueryResult<SearchUserByEmailQuery, SearchUserByEmailQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($id: Int!) {
  user(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}`;
export type UserByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<UserByIdQuery, UserByIdQueryVariables>, 'query'> & ({ variables: UserByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UserByIdComponent = (props: UserByIdComponentProps) => (
      <ApolloReactComponents.Query<UserByIdQuery, UserByIdQueryVariables> query={UserByIdDocument} {...props} />
    );
    

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
      }
export function useUserByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = ApolloReactCommon.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const MasksDocument = gql`
    query Masks($courseId: Int!, $rank: Int!) {
  nouns: wordsMasks(course: $courseId, rank: $rank, pos: "n") {
    ...MaskFragment
  }
  adjectives: wordsMasks(course: $courseId, rank: $rank, pos: "a") {
    ...MaskFragment
  }
  verbs: wordsMasks(course: $courseId, rank: $rank, pos: "v") {
    ...MaskFragment
  }
  other: wordsMasks(course: $courseId, rank: $rank, pos: "o") {
    ...MaskFragment
  }
}
    ${MaskFragmentFragmentDoc}`;
export type MasksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MasksQuery, MasksQueryVariables>, 'query'> & ({ variables: MasksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MasksComponent = (props: MasksComponentProps) => (
      <ApolloReactComponents.Query<MasksQuery, MasksQueryVariables> query={MasksDocument} {...props} />
    );
    

/**
 * __useMasksQuery__
 *
 * To run a query within a React component, call `useMasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasksQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasksQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      rank: // value for 'rank'
 *   },
 * });
 */
export function useMasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MasksQuery, MasksQueryVariables>) {
        return ApolloReactHooks.useQuery<MasksQuery, MasksQueryVariables>(MasksDocument, baseOptions);
      }
export function useMasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MasksQuery, MasksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MasksQuery, MasksQueryVariables>(MasksDocument, baseOptions);
        }
export type MasksQueryHookResult = ReturnType<typeof useMasksQuery>;
export type MasksLazyQueryHookResult = ReturnType<typeof useMasksLazyQuery>;
export type MasksQueryResult = ApolloReactCommon.QueryResult<MasksQuery, MasksQueryVariables>;
export const GetWordByIdDocument = gql`
    query GetWordById($id: Int!) {
  word(id: $id) {
    id
    lemma
    predefinedTranslation {
      id
    }
  }
}
    `;
export type GetWordByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWordByIdQuery, GetWordByIdQueryVariables>, 'query'> & ({ variables: GetWordByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetWordByIdComponent = (props: GetWordByIdComponentProps) => (
      <ApolloReactComponents.Query<GetWordByIdQuery, GetWordByIdQueryVariables> query={GetWordByIdDocument} {...props} />
    );
    

/**
 * __useGetWordByIdQuery__
 *
 * To run a query within a React component, call `useGetWordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWordByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWordByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWordByIdQuery, GetWordByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetWordByIdQuery, GetWordByIdQueryVariables>(GetWordByIdDocument, baseOptions);
      }
export function useGetWordByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWordByIdQuery, GetWordByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetWordByIdQuery, GetWordByIdQueryVariables>(GetWordByIdDocument, baseOptions);
        }
export type GetWordByIdQueryHookResult = ReturnType<typeof useGetWordByIdQuery>;
export type GetWordByIdLazyQueryHookResult = ReturnType<typeof useGetWordByIdLazyQuery>;
export type GetWordByIdQueryResult = ApolloReactCommon.QueryResult<GetWordByIdQuery, GetWordByIdQueryVariables>;